<template>
    <div class="landing-container" :class="{ 'expanded': sessionId || showVoiceSession, 'chat-active': isManuallyExpanded, 'dark-mode': isDarkMode }">
        
       
        
        <!-- Toggle button when sidebar is hidden -->
        <button v-if="(sessionId || showVoiceSession) && !showSessionHistory" 
                class="show-history-btn"
                @click="showSessionHistory = true"
                title="Show session history">
            <i class="mdi mdi-history"></i>
        </button>

        <div class="ai-content-wrapper" :class="{ 'chat-started': sessionId || showVoiceSession, 'full-chat': isManuallyExpanded, 'with-sidebar': showSessionHistory }">
           <!-- Session History Sidebar -->
          <div v-if="(sessionId || showVoiceSession) && showSessionHistory" class="session-history-sidebar">
              <div class="session-history-header">
                  <h3>Session History</h3>
                  <div class="session-header-actions">
                      <button class="new-chat-btn" @click="startNewSession" title="Start new chat">
                          <i class="mdi mdi-plus"></i>
                      </button>
                      <button class="toggle-history-btn" @click="showSessionHistory = false" title="Hide session history">
                          <i class="mdi mdi-chevron-left"></i>
                      </button>
                  </div>
              </div>
              
              <div class="session-history-content">
                  <div class="session-list-container" @scroll="handleSessionScroll" ref="sessionListContainer">
                      <div v-if="loadingHistory" class="loading-sessions">
                          <i class="mdi mdi-loading mdi-spin"></i>
                          <span>Loading sessions...</span>
                      </div>
                      
                      <div v-else class="session-list">
                          <div v-for="session in displayedSessions" 
                              :key="session.sessionId" 
                              class="session-item"
                              :class="{ 'active': session.sessionId === sessionId, 'main-session': session.isMainSession }"
                              @click="loadSession(session.sessionId)">
                              <div class="session-header">
                                  <div class="session-title">
                                      <span v-if="session.isMainSession" class="main-session-label">Current Session: </span>
                                      {{ session.title || 'Chat Session' }}
                                  </div>
                                  <div class="session-status" :class="session.sessionStatus.toLowerCase()">
                                      <i :class="session.sessionStatus === 'Resolved' ? 'mdi mdi-check-circle' : 'mdi mdi-clock-outline'"></i>
                                      <span>{{ session.sessionStatus === 'Resolved' ? 'Completed' : 'Active' }}</span>
                                  </div>
                              </div>
                              <div class="session-body">
                                  <div class="session-date">{{ formatSessionDate(session.createdAt) }}</div>
                                  <div class="session-preview">{{ session.preview }}</div>
                                  <div class="session-id">ID: {{ session.sessionId }}</div>
                              </div>
                              <div class="session-footer">
                                  <span class="message-count">
                                      <i class="mdi mdi-message-outline"></i>
                                      {{ session.messageCount }} {{ session.messageCount === 1 ? 'message' : 'messages' }}
                                  </span>
                                  <span class="session-duration" v-if="session.sessionDuration">
                                      <i class="mdi mdi-timer-outline"></i>
                                      {{ formatDuration(session.sessionDuration) }}
                                  </span>
                              </div>
                          </div>
                      </div>
                      
                      <!-- Loading more sessions indicator -->
                      <div v-if="loadingHistory && sessionHistory.length > 0" class="loading-more-sessions">
                          <i class="mdi mdi-loading mdi-spin"></i>
                          <span>Loading more sessions...</span>
                      </div>
                  </div>
              </div>
          </div>
            <!-- Content Container for expanded state -->
            <div v-if="sessionId || showVoiceSession" class="expanded-content-container">
                <!-- Management Cards -->
                <div v-if="sessionId && !showVoiceSession" class="management-cards">
                <div class="management-card">
                    <!-- <h3>Employee Management</h3> -->
                    <div class="card-buttons">
                        <button class="card-button" @click="openModuleChat('employee-list')">
                            <i class="mdi mdi-account-group"></i>
                            <span>Employee List</span>
                        </button>
                        <button class="card-button" @click="openModuleChat('add-employee')">
                            <i class="mdi mdi-account-plus"></i>
                            <span>Add Employee</span>
                        </button>
                    </div>
                </div>
                <div class="management-card">
                    <!-- <h3>Payroll Management</h3> -->
                    <div class="card-buttons">
                        <button class="card-button" @click="openModuleChat('view-payroll')">
                            <i class="mdi mdi-cash-multiple"></i>
                            <span>View Payroll</span>
                        </button>
                        <button class="card-button" @click="openModuleChat('new-pay-item')">
                            <i class="mdi mdi-cash-plus"></i>
                            <span>New Pay Item</span>
                        </button>
                    </div>
                </div>
                <div class="management-card">
                    <!-- <h3>Transition Management</h3> -->
                    <div class="card-buttons">
                        <button class="card-button" @click="openModuleChat('view-process')">
                            <i class="mdi mdi-clipboard-list"></i>
                            <span>View Process</span>
                        </button>
                        <button class="card-button" @click="openModuleChat('new-request')">
                            <i class="mdi mdi-clipboard-plus"></i>
                            <span>New Request</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Chat Container -->
            <div v-if="sessionId && !showVoiceSession " class="chat-container" :class="{ 'full-height': isManuallyExpanded }">
                
                <!-- Chat Header with Back Button (only show when chat is active) -->
                <div class="chat-header">
                    <div class="chat-header-container">
                    <div class="chat-title">
                        <span class="service-icon">🤖</span>
                        <div class="service-info">
                            <div class="flex items-center">
                                <span class="service-name">HR AI Assistant</span>
                                <span v-if="sessionId" class="session-id-display">({{ sessionId }})</span>
                            </div>
                            <div v-if="currentModule" class="chat-context">
                                <i :class="getModuleIcon(currentModule)"></i>
                                <span>{{ getModuleName(currentModule) }}</span>
                            </div>
                            <div v-else-if="websocket" class="chat-context">
                                <i :class="getConnectionStatusIcon()"></i>
                                <span>{{ getConnectionStatusText() }}</span>
                                <button v-if="websocket?.readyState !== 1" 
                                        class="reconnect-button" 
                                        @click="manualReconnect()"
                                        title="Reconnect to server"
                                        aria-label="Reconnect">
                                    <i class="mdi mdi-refresh"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="chat-actions">
                        <div class="new-chat-section">
                            <button class="back-button" @click="endChat('button')" :disabled="messages.length === 0" aria-label="Back to main page">
                                <i class="mdi mdi-plus"></i>
                                <span>New Chat</span>
                            </button>
                            <button class="expand-button" 
                                    @click="toggleFullScreen()" 
                                    :title="isManuallyExpanded ? 'Reduce to normal view' : 'Expand to full screen'">
                                <i :class="isManuallyExpanded ? 'mdi mdi-fullscreen-exit' : 'mdi mdi-fullscreen'"></i>
                            </button>
                        </div>
                    </div>
                    </div> <!-- End chat-header-container -->
                </div>

                <div class="chat-messages" ref="chatMessages" role="log" aria-live="polite">
                    <div class="chat-messages-container">
                    <!-- Welcome message when no messages -->
                    <div v-if="messages.length === 0" class="message assistant-message" role="article">
                        <div class="message-avatar" role="img" aria-label="AI Assistant">
                            <i class="mdi mdi-robot"></i>
                        </div>
                        <div class="message-content">
                            <div class="message-header">
                                <span class="message-sender">HR AI Assistant</span>
                                <span class="message-time">{{ formatTime(new Date()) }}</span>
                            </div>
                            <div class="message-text">
                                <div v-if="currentModule" class="welcome-context">
                                    <div class="context-badge">
                                        <i :class="getModuleIcon(currentModule)"></i>
                                        <span>{{ getModuleName(currentModule) }}</span>
                                    </div>
                                </div>
                                Welcome to the <strong>HR AI Assistant</strong>! <span v-if="currentModule">I'm here to help you with <strong>{{ getModuleName(currentModule) }}</strong>.</span><span v-else>I'm here to help you with all your human resources needs, from employee management to payroll and benefits.</span> How can I assist you today?
                                </div>
                        </div>
                    </div>

                   

                    <!-- Chat messages -->
                    <div v-for="(msg, idx) in messages" :key="idx"
                        :class="['message', msg.role === 'assistant' ? 'assistant-message' : 'user-message']"
                        role="article">
                        <div class="message-avatar" role="img"
                            :aria-label="msg.role === 'assistant' ? 'AI Assistant' : 'User'">
                            <i :class="msg.role === 'assistant' ? 'mdi mdi-robot' : 'mdi mdi-account'"></i>
                        </div>
                        <div class="message-content">
                            <div class="message-header">
                                <span class="message-sender">{{ msg.role === 'assistant' ? 'HR AI Assistant' : 'You' }}</span>
                                <span class="message-time">{{ formatTime(new Date(msg.timestamp)) }}</span>
                            </div>
                            <div class="message-text">
                                <div v-if="shouldTruncateMessage(msg.content) && !isMessageExpanded(idx)" 
                                     v-html="formatMessageContent(getTruncatedContent(msg.content))"
                                     class="truncated-content">
                                </div>
                                <div v-else v-html="formatMessageContent(msg.content)"></div>
                                
                                <!-- Streaming indicator for assistant messages -->
                                <div v-if="msg.streaming && msg.role === 'assistant'" class="streaming-indicator">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                
                                <!-- Message actions - always show if message is long or has export options -->
                                <div v-if="shouldTruncateMessage(msg.content) || shouldShowExportOptions(msg.content, msg.role)" class="message-actions">
                                    <!-- Manual expand/collapse button for long messages -->
                                    <button v-if="shouldTruncateMessage(msg.content)"
                                            @click="toggleMessageExpansion(idx)"
                                            class="expand-btn"
                                            :title="isMessageExpanded(idx) ? 'Collapse message' : 'Expand message'">
                                        <i :class="isMessageExpanded(idx) ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'"></i>
                                    </button>
                                    
                                    <!-- Export buttons for truncated messages -->
                                    <button v-if="shouldTruncateMessage(msg.content)"
                                            @click="exportMessage('pdf', idx)"
                                            class="export-btn export-pdf-btn"
                                            :disabled="isExporting"
                                            title="Export message as PDF">
                                        <i class="mdi mdi-file-pdf-box"></i>
                                        {{ isExporting === 'pdf' ? 'Exporting...' : 'Export PDF' }}
                                    </button>
                                    
                                    <button v-if="shouldTruncateMessage(msg.content)"
                                            @click="exportMessage('excel', idx)"
                                            class="export-btn export-excel-btn"
                                            :disabled="isExporting"
                                            title="Export message as Excel">
                                        <i class="mdi mdi-file-excel"></i>
                                        {{ isExporting === 'excel' ? 'Exporting...' : 'Export Excel' }}
                                    </button>
                                    
                                    <!-- Standalone export buttons for export-enabled messages -->
                                    <button v-if="shouldShowExportOptions(msg.content, msg.role) && !shouldTruncateMessage(msg.content)"
                                            @click="exportMessage('pdf', idx)"
                                            class="export-btn export-pdf-btn standalone-export"
                                            :disabled="isExporting"
                                            title="Export as PDF">
                                        <i class="mdi mdi-file-pdf-box"></i>
                                        {{ isExporting === 'pdf' ? 'Exporting...' : 'Export PDF' }}
                                    </button>
                                    
                                    <button v-if="shouldShowExportOptions(msg.content, msg.role) && !shouldTruncateMessage(msg.content)"
                                            @click="exportMessage('excel', idx)"
                                            class="export-btn export-excel-btn standalone-export"
                                            :disabled="isExporting"
                                            title="Export as Excel">
                                        <i class="mdi mdi-file-excel"></i>
                                        {{ isExporting === 'excel' ? 'Exporting...' : 'Export Excel' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                     <!-- Loading session indicator -->
                    <div v-if="loadingSession" class="message assistant-message loading-session" role="article">
                        <div class="message-avatar" role="img" aria-label="AI Assistant">
                            <i class="mdi mdi-robot"></i>
                        </div>
                        <div class="message-content">
                            <div class="message-header">
                                <span class="message-sender">HR AI Assistant</span>
                                <span class="message-time">{{ formatTime(new Date()) }}</span>
                            </div>
                            <div class="message-text">
                                <div class="loading-session-text">
                                    <i class="mdi mdi-loading mdi-spin"></i>
                                    <span>Loading session history...</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Typing Indicator -->
                    <div v-if="loading && !hasStreamingMessage()" class="message assistant-message" role="status" aria-live="polite">
                        <div class="message-avatar">
                            <i class="mdi mdi-robot"></i>
                        </div>
                        <div class="message-content">
                            <div class="typing-indicator" aria-label="AI is typing">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                    </div> <!-- End chat-messages-container -->
                </div>

                <!-- Suggestion chips when no messages -->
                <div v-if="messages.length === 0 && !loading" class="suggestions-bar">
                    <div class="suggestions-container">
                    <div v-if="currentModule" class="module-suggestions">
                        <div v-for="suggestion in getModuleSuggestions(currentModule)" :key="suggestion" 
                             class="suggestion-chip" @click="sendSuggestion(suggestion)">
                            {{ suggestion }}
                        </div>
                    </div>
                    <div v-else class="general-suggestions">
                        <div class="suggestion-chip" @click="sendSuggestion('List all employees')">
                          Employee Management
                        </div>
                        <div class="suggestion-chip" @click="sendSuggestion('What is the total payroll cost for August 2025?')">
                          Payroll Analysis
                        </div>
                        <div class="suggestion-chip" @click="sendSuggestion('Show pending leave requests awaiting approval')">
                            Leave Management
                        </div>
                        <div class="suggestion-chip" @click="sendSuggestion('Which employees have overdue mandatory training?')">
                            Training Status
                        </div>
                    </div>
                    </div> <!-- End suggestions-container -->
                </div>

                <div class="chat-input">
                    <div class="chat-input-container">
                    <div class="input-actions">
                        <button class="attachment-btn" @click="triggerFileUpload" title="Attach File"
                            aria-label="Attach file">
                            <i class="mdi mdi-paperclip"></i>
                        </button>
                        <input type="file" ref="fileInput" @change="handleFileUpload"
                            accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png" style="display: none;"
                            aria-label="File upload" />
                    </div>

                    <textarea v-model="question" placeholder="Type your HR-related question..." class="message-input"
                        @keydown="handleKeyDown" 
                        :disabled="loading || (websocket && websocket?.readyState !== 1)" 
                        aria-label="Type your message"
                        maxlength="1000"
                        rows="1"
                        style="resize: none; overflow-y: hidden;"
                        @input="autoResize"
                        ref="messageInput"></textarea>

                    <!-- Connection status indicator when disconnected -->
                    <div v-if="websocket && websocket?.readyState !== 1" class="connection-status-badge">
                        <i :class="getConnectionStatusIcon()"></i>
                        <span>{{ getConnectionStatusText() }}</span>
                        <button class="reconnect-button small" 
                                @click="manualReconnect()"
                                title="Reconnect to server"
                                aria-label="Reconnect">
                            <i class="mdi mdi-refresh"></i>
                        </button>
                    </div>

                    <button class="send-button" 
                        @click="handleButtonClick()" 
                        :disabled="!canSendMessage()"
                        :class="{ 'stop-button': loading }"
                        :aria-label="loading ? 'Stop message' : 'Send message'"
                        :title="getSendButtonTooltip()">
                        <i :class="loading ? 'mdi mdi-stop' : 'mdi mdi-send'"></i>
                    </button>
                    </div> <!-- End chat-input-container -->
                </div>
            </div>

            <!-- Quick Actions (Horizontal) -->
            <div v-if="sessionId && !showVoiceSession " class="quick-actions-horizontal">
                <h3>Quick Actions</h3>
                <div class="quick-actions-grid">
                    <div class="quick-action-item" @click="openModuleChat('add-new-employee')" title="Assets">
                        <i class="mdi mdi-briefcase"></i>
                        <span>Add New Employee</span>
                        <div class="ai-indicator">
                            <i class="mdi mdi-flash"></i>
                        </div>
                    </div>
                    <div class="quick-action-item" @click="openModuleChat('training-development')" title="Training & Development">
                        <i class="mdi mdi-school"></i>
                        <span>Training & Development</span>
                        <div class="ai-indicator">
                            <i class="mdi mdi-flash"></i>
                        </div>
                    </div>
                    <div class="quick-action-item" @click="openModuleChat('recruitment')" title="Recruitment">
                        <i class="mdi mdi-account-search"></i>
                        <span>Recruitment</span>
                        <div class="ai-indicator">
                            <i class="mdi mdi-flash"></i>
                        </div>
                    </div>
                    <div class="quick-action-item" @click="openModuleChat('requests')" title="Requests">
                        <i class="mdi mdi-clipboard-text"></i>
                        <span>Requests</span>
                        <div class="ai-indicator">
                            <i class="mdi mdi-flash"></i>
                        </div>
                    </div>
                </div>
            </div>
            </div> <!-- End expanded-content-container -->
        </div>

        <!-- Voice session UI -->
        <div v-if="showVoiceSession" class="voice-session-container">
            <div class="voice-content-container">
            <div class="voice-header">
                <div class="voice-branding">
                    <div class="voice-logo">
                        <div class="logo-pulse"></div>
                        <span class="voice-icon">🎤</span>
                    </div>
                    <div class="voice-title">
                        <h3>HR AI Voice Assistant</h3>
                        <p>Speak naturally, I'm listening...</p>
                    </div>
                </div>
            </div>

            <div class="voice-content">
                <div v-if="!isSessionActive" class="voice-connecting">
                    <div class="connection-spinner">
                        <div class="spinner-ring"></div>
                        <div class="spinner-ring"></div>
                        <div class="spinner-ring"></div>
                    </div>
                    <p>Connecting to voice agent...</p>
                </div>

                <div v-else class="voice-active">
                    <div class="voice-visualizer">
                        <div class="visualizer-container">
                            <div class="voice-waves">
                                <div class="wave" v-for="n in 5" :key="n" :class="{ 'active': pulseLoading }"></div>
                            </div>
                            <div class="voice-avatar">
                                <img src="@/assets/loading.gif" alt="AI Avatar" class="ai-avatar-gif"
                                    :class="{ 'pulse-animation': pulseLoading }"
                                    :style="{ animationDuration: pulseLoading ? pulseDuration : undefined }"
                                    @animationend="pulseLoading = false" />
                            </div>
                        </div>
                    </div>

                    <div class="voice-status">
                        <div class="status-indicator" :class="{ 'listening': pulseLoading }">
                            <div class="status-dot"></div>
                            <span>{{ pulseLoading ? 'Listening...' : 'Ready to talk' }}</span>
                        </div>
                    </div>

                    <div class="voice-controls">
                        <div class="control-hint">
                            <span>💡 Tip: Speak clearly and naturally</span>
                        </div>
                        <button @click="closeVoiceSession" class="end-voice-btn">End Voice Session</button>
                    </div>
                </div>
            </div>

            <div class="voice-footer">
                <div class="tech-badge">
                    <span class="badge-icon">⚡</span>
                    <span>Powered by Nathan Digital AI</span>
                </div>
            </div>
            </div> <!-- End voice-content-container -->
        </div>

        <!-- Feedback Modal -->
        <div v-if="showFeedback" class="feedback-overlay">
            <div class="feedback-modal">
                <div class="feedback-header">
                    <div class="feedback-icon">
                        <div class="feedback-logo">💬</div>
                    </div>
                    <h3>How was your experience?</h3>
                    <p>Your feedback helps us improve our service</p>
                </div>

                <div v-if="!feedbackSubmitted" class="feedback-content">
                    <div class="rating-container">
                        <div class="rating-label">Rate your experience:</div>
                        <div class="rating-smileys">
                            <div v-for="rating in [5, 4, 3, 2, 1]" :key="rating" class="smiley-rating"
                                :class="{ 'active': feedbackRating === rating, 'hover': feedbackRating === 0 }"
                                @click="setFeedbackRating(rating)" @mouseenter="feedbackRating === 0 && setFeedbackRating(rating)"
                                @mouseleave="feedbackRating === 0 && setFeedbackRating(0)">
                                <div class="smiley">{{ getSmileyIcon(rating) }}</div>
                                <div class="rating-text">{{ getRatingText(rating) }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="feedback-actions">
                        <button @click="skipFeedback" class="feedback-btn secondary">
                            Skip
                        </button>
                        <button @click="submitFeedback" :disabled="feedbackRating === 0" class="feedback-btn primary">
                            Submit Feedback
                        </button>
                    </div>
                </div>

                <div v-else class="feedback-success">
                    <div class="success-icon">✨</div>
                    <h4>Thank you for your feedback!</h4>
                    <p>Your input helps us serve you better.</p>
                </div>
            </div>
        </div>

        <audio ref="audioElement" autoplay controls style="display: none;"></audio>
    </div>
</template>

<script>
// import { ref, reactive, nextTick } from 'vue';

export default {
  name: 'HRMSChatBox',
  data() {
    return {
      toolsArray: [],
      systemURL: "",
      systemAuthConfig: null,
      dynamicValues: false,
      pulseDuration: '2s',
      pulseInterval: null, // Store the interval ID for pulse animation
      pulseLoading: true,
      question: '',
      systemMessageFile: 'HRMS',
      answer: '',
      error: '',
      loading: false,
      sessionId: null,
      messages: [],
      showEmojiPicker: false,
      showVoiceSession: false,
      isSessionActive: false,
      events: [],
      dataChannel: null,
      peerConnection: null,
      audioElement: null,
      userID: "65d091b6fa762b988d4966b8", // Example user ID, replace with actual user ID logic
      voiceSessions: {}, // Store voice sessions by sessionId
      showFeedback: false,
      feedbackRating: 0,
      feedbackSubmitted: false,
      currentModule: null, // Track the current module context
      expandedMessages: new Set(), // Track which messages are expanded
      isExporting: null, // Track export state (null, 'pdf', 'excel')
      abortController: null, // For cancelling API requests
      unhandledRejectionHandler: null, // For cleanup of global error handler
      websocket: null, // WebSocket connection
      reconnectAttempts: 0, // Track reconnection attempts
      maxReconnectAttempts: 3, // Maximum reconnection attempts
      heartbeatInterval: null, // Heartbeat interval for keeping connection alive
      isManuallyExpanded: false, // Track manual expansion state
      // Session History
      sessionHistory: [], // List of previous sessions
      currentPage: 1, // Current page for pagination
      sessionsPerPage: 10, // Sessions per page
      totalSessions: 0, // Total number of sessions
      loadingHistory: false, // Loading state for session history
      loadingSession: false, // Loading state for individual session
      mainSessionId: null, // The primary/latest session being worked on
      showSessionHistory: false, // Toggle sidebar visibility
      alreadyNewSession: null,
      // Theme support
      isDarkMode: false // Track dark mode state
    };
  },
  mounted() {
    // Set custom title and favicon
    document.title = 'HR AI Assistant - Human Resources Management'

    // Set custom favicon
    const link = document.querySelector('link[rel="icon"]') || document.createElement('link')
    link.rel = 'icon'
    link.href = 'https://www.westerncape.gov.za/sites/www.westerncape.gov.za/themes/westerncape/images/favicon.ico'
    if (!document.querySelector('link[rel="icon"]')) {
      document.head.appendChild(link)
    }

    // Check for URL params for systemMessageFile and userID
    const urlParams = new URLSearchParams(window.location.search);
    const systemMessageFile = urlParams.get('systemMessageFile');
    const userID = urlParams.get('userID');
    const autoStart = urlParams.get('startChat') === 'true';
    const theme = urlParams.get('theme');
    
    // Check for dark mode theme
    if (theme === 'dark') {
      this.isDarkMode = true;
      document.body.classList.add('dark-mode');
    }
    
    if (autoStart) {
      this.startChat();
    }
    if (systemMessageFile) {
      this.systemMessageFile = systemMessageFile;
      this.dynamicValues = true;
    }
    if (userID) {
      this.userID = userID;
      this.dynamicValues = true;
    }
    let sessionParamId = new URLSearchParams(window.location.search).get('sessionId');
    if (sessionParamId) {
      this.startChat();
    }

    // Add mobile scrolling optimization
    this.$nextTick(() => {
      const chatMessages = this.$refs.chatMessages;
      if (chatMessages) {
        // Force initial scroll position
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }
    });

    // Store the handler reference for cleanup
    this.unhandledRejectionHandler = (event) => {
      if (event.reason?.name === 'AbortError' || event.reason?.message?.includes('aborted')) {
        event.preventDefault();
      }
    };
    window.addEventListener('unhandledrejection', this.unhandledRejectionHandler);
    
    // Load session history list
    this.loadSessionsList();
  },
  beforeUnmount() {
    // Clean up global error handler
    if (this.unhandledRejectionHandler) {
      window.removeEventListener('unhandledrejection', this.unhandledRejectionHandler);
    }
    
    // Clean up dark mode class
    document.body.classList.remove('dark-mode');
    
    // Clean up any pending requests
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    
    // Clean up WebSocket connection
    this.closeWebSocketConnection();
    
    // Clean up heartbeat interval
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalSessions / this.sessionsPerPage);
    },
    
    displayedSessions() {
      const sessions = [];
      
      // Add the main session at the top if it exists and has messages
      if (this.mainSessionId && this.sessionId === this.mainSessionId && this.messages.length > 0) {
        sessions.push({
          sessionId: this.mainSessionId,
          title: this.generateCurrentSessionTitle(),
          createdAt: new Date().toISOString(),
          preview: this.generateCurrentSessionPreview(),
          messageCount: this.messages.length,
          sessionStatus: 'Active',
          summery: this.generateCurrentSessionSummary(),
          isMainSession: true
        });
      }
      
      // Add history sessions, but exclude the main session if it's in there
      const historyToShow = this.sessionHistory.filter(session => session.sessionId !== this.mainSessionId);
      sessions.push(...historyToShow);
      
      return sessions;
    }
  },
  watch: {
    messages: {
      handler(newMessages, oldMessages) {
        // Only auto-scroll if messages were added (not just changed)
        if (newMessages.length > (oldMessages?.length || 0)) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToBottom();
            }, 50);
          });
        }
      },
      deep: true
    }
  },
  methods: {
    formatTime(date) {
      return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },

    handleKeyDown(event) {
      // Handle Enter key press
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // Shift+Enter: Allow default behavior (new line)
          // Don't prevent default, let the textarea handle the new line
          return;
        } else {
          // Regular Enter: Send message
          event.preventDefault(); // Prevent default form submission
          if (!this.loading && this.question.trim() && this.canSendMessage()) {
            this.handleButtonClick();
          }
        }
      }
    },

    autoResize(event) {
      const textarea = event.target;
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = 'auto';
      // Set height based on scrollHeight, with min and max limits
      const newHeight = Math.min(Math.max(textarea.scrollHeight, 40), 120); // Min 40px, max 120px
      textarea.style.height = newHeight + 'px';
    },

    resetTextareaHeight() {
      // Reset textarea height to default when question is cleared
      this.$nextTick(() => {
        const textarea = this.$refs.messageInput;
        if (textarea) {
          textarea.style.height = '48px'; // Default height
        }
      });
    },

    hasStreamingMessage() {
      // Check if there's currently a streaming message (assistant message with streaming=true)
      return this.messages.some(msg => msg.role === 'assistant' && msg.streaming === true);
    },

    // Message expansion methods
    shouldTruncateMessage(content) {
      if (!content) return false;
      // Count the number of lines by splitting on both \n and \\n
      const lineCount = content.split(/\\n|\n/).length;
      return lineCount > 15;
    },

    shouldShowExportOptions(content, role) {
      if (!content || role !== 'assistant') return false;
      const contentLower = content.toLowerCase();
      return ( contentLower.includes('export to pdf') || contentLower.includes('export to excel')) && !contentLower.includes('further details');
    },

    getTruncatedContent(content) {
      if (!content) return '';
      // Split content by line breaks and take only first 15 lines
      const lines = content.split(/\\n|\n/);
      return lines.slice(0, 15).join('\n');
    },

    isMessageExpanded(messageIndex) {
      return this.expandedMessages.has(messageIndex);
    },

    toggleMessageExpansion(messageIndex) {
      if (this.expandedMessages.has(messageIndex)) {
        this.expandedMessages.delete(messageIndex);
      } else {
        this.expandedMessages.add(messageIndex);
      }
      // Force reactivity update
      this.$forceUpdate();
      
      // Scroll to maintain position after expansion
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    downloadFile(blob, exportType) {
      try {
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Generate more descriptive filename
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const moduleName = this.currentModule ? 
          this.getModuleName(this.currentModule).replace(/\s+/g, '-') : 
          'General-HR';
        const queryType = this.lastQueryType || 'Export';
        const fileExtension = exportType === 'pdf' ? 'pdf' : 'xlsx';
        
        link.download = `HR-Assistant-${moduleName}-${queryType}-${timestamp}.${fileExtension}`;
        
        // Make download more reliable
        link.style.display = 'none';
        document.body.appendChild(link);
        
        // Trigger download with a small delay for better browser compatibility
        setTimeout(() => {
          link.click();
          document.body.removeChild(link);
          
          // Clean up the URL object after a delay
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);
        }, 100);
        
      } catch (error) {
        console.error('Download error:', error);
        this.showErrorMessage('Failed to download file. Please try again.');
      }
    },

    async exportMessage(exportType, messageIndex) {
      if (this.isExporting) return;
      
      this.isExporting = exportType;
      
      try {
        // Find the previous user question for this assistant answer
        let userQuestion = '';
        let assistantAnswer = '';
        
        // Look backwards from the current message index to find the most recent user message
        for (let i = messageIndex - 1; i >= 0; i--) {
          if (this.messages[i] && this.messages[i].role === 'user') {
            userQuestion = this.messages[i].content;
            break;
          }
        }
        
        // Get the assistant answer at the current message index
        if (this.messages[messageIndex] && this.messages[messageIndex].role === 'assistant') {
          assistantAnswer = this.messages[messageIndex].content;
        }
        
        // Prepare the export data with the user question and assistant answer
        const exportData = {
          sessionId: this.sessionId,
          question: userQuestion,
          answer: assistantAnswer,
          exportType: exportType
        };

        // Call the export API
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/export`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(exportData)
        });

        if (!response.ok) {
          throw new Error(`Export failed: ${response.status} ${response.statusText}`);
        }

        // Handle the response
        const blob = await response.blob();
        
        this.downloadFile(blob, exportType);
        
        // Show success notification
        const exportTypeName = exportType.toUpperCase();
        this.showNotification(`${exportTypeName} exported successfully!`, 'success');
        
      } catch (error) {
        this.showNotification(`Failed to export ${exportType.toUpperCase()}. Please try again.`, 'error');
      } finally {
        this.isExporting = null;
      }
    },

    showNotification(message, type = 'info') {
      // Simple notification system - you can enhance this with a proper toast library
      const notification = document.createElement('div');
      notification.className = `notification notification-${type}`;
      notification.textContent = message;
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#3b82f6'};
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 500;
        max-width: 300px;
        transition: all 0.3s ease;
      `;
      
      document.body.appendChild(notification);
      
      // Auto remove after 3 seconds
      setTimeout(() => {
        if (notification.parentNode) {
          notification.style.opacity = '0';
          notification.style.transform = 'translateX(100%)';
          setTimeout(() => {
            document.body.removeChild(notification);
          }, 300);
        }
      }, 3000);
    },
    
    openEmail() {
      window.open('mailto:support@hr-ai-assistant.com', '_blank');
    },

    openCalendar() {
      // Implement calendar opening logic
    },

    openModuleChat(module) {
      // Map modules to appropriate system messages
      const moduleMap = {
        'employee-list': 'HRMS',
        'add-employee': 'HRMS', 
        'view-payroll': 'HRMS',
        'new-pay-item': 'HRMS',
        'view-process': 'HRMS',
        'new-request': 'HRMS',
        'assets': 'HRMS',
        'training-development': 'HRMS',
        'add-new-employee': 'HRMS',
        'recruitment': 'HRMS',
        'requests': 'HRMS'
      };
      
      this.currentModule = module;
      this.systemMessageFile = moduleMap[module] || 'HRMS';
      
      // End current session and start a new one for the selected module
      this.startNewSession();
    },

    async startNewSession() {
      try {
        // Check if current session is empty - if so, reuse it instead of creating new one
        if(this.alreadyNewSession == null && this.sessionId && this.messages.length < 1) {
          this.alreadyNewSession = this.sessionId;
        }else if(this.alreadyNewSession && this.sessionId && this.messages.length > 0) {
          this.loadSession(this.alreadyNewSession);
        }
        if(this.alreadyNewSession) {
          this.sessionId = this.alreadyNewSession;
          this.mainSessionId = this.sessionId; // Mark this as the main session
          
          // Ensure WebSocket is connected for the existing session
          if (!this.websocket || this.websocket?.readyState !== WebSocket.OPEN) {
            await this.initializeWebSocketSession();
          }
          return; // Exit early - reusing existing session
        }
        if (this.sessionId && this.messages.length === 0) {
          
          // Clear any potential error state and ensure this is marked as main session
          this.error = '';
          this.question = '';
          this.answer = '';
          this.mainSessionId = this.sessionId;
          
          // Ensure WebSocket is connected for the existing session
          if (!this.websocket || this.websocket?.readyState !== WebSocket.OPEN) {
            await this.initializeWebSocketSession();
          }
          
          return; // Exit early - reusing existing empty session
        }

        // Save current session to history if it exists and has messages
        if (this.sessionId && this.messages.length > 0) {
          await this.saveCurrentSessionToHistory();
        }

        // Close WebSocket connection
        this.closeWebSocketConnection();

        // Clear current state
        this.messages = [];
        this.expandedMessages.clear();
        this.isManuallyExpanded = false;
        this.question = '';
        this.answer = '';
        this.error = '';

        // Generate new session ID
        this.sessionId = this.generateSessionId('ct');
        this.mainSessionId = this.sessionId; // Mark this as the main session

        // Update URL with new session ID
        const url = new URL(window.location);
        url.searchParams.set('sessionId', this.sessionId);
        window.history.replaceState({}, document.title, url.pathname + url.search);

        // Start new session
        await this.initializeWebSocketSession();
        
      } catch (error) {
        console.error('Error starting new session:', error);
        this.error = 'Failed to start new session. Please try again.';
      }
    },

    async endCurrentSessionAndStartNew() {
      // If there's an active session, end it first
      if (this.sessionId) {
        try {
          await fetch(`${process.env.VUE_APP_API_BASE_URL}/chat/v3/end`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sessionId: this.sessionId })
          });
        } catch (error) {
          console.warn('Error ending previous session:', error);
        }
      }

      // Close WebSocket connection
      this.closeWebSocketConnection();

      // Clear current state
      this.sessionId = null;
      this.messages = [];
      this.expandedMessages.clear(); // Clear expanded messages
      this.isManuallyExpanded = false; // Reset manual expansion
      this.question = '';
      this.answer = '';
      this.error = '';

      // Remove sessionId from URL
      const url = new URL(window.location);
      url.searchParams.delete('sessionId');
      window.history.replaceState({}, document.title, url.pathname + url.search);

      // Start new session
      this.startChat();
    },

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Handle file upload logic here
      }
    },
    showFeedbackModal() {
      this.showFeedback = true;
      this.feedbackRating = 0;
      this.feedbackSubmitted = false;
    },
    setFeedbackRating(rating) {
      this.feedbackRating = rating;
    },
    submitFeedback() {
      if (this.feedbackRating > 0) {
        // Here you would typically send the feedback to your API
        this.feedbackSubmitted = true;

        // Close feedback after 1.5 seconds and proceed with ending session
        setTimeout(() => {
          this.showFeedback = false;
        }, 1500);
      }
    },
    skipFeedback() {
      this.showFeedback = false;
    },
    getSmileyIcon(rating) {
      const smileys = {
        1: '😞',
        2: '😐',
        3: '🙂',
        4: '😊',
        5: '😍'
      };
      return smileys[rating];
    },
    getRatingText(rating) {
      const texts = {
        1: 'Poor',
        2: 'Fair',
        3: 'Good',
        4: 'Great',
        5: 'Excellent'
      };
      return texts[rating];
    },
    async updateContext(conversation, sessionId, systemMessageFile) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/chat/sessionUpdate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ conversation, sessionId, systemMessageFile })
        });

        if (!response.ok) {
          console.warn('Failed to update context:', response.status);
          return;
        }

        await response.json();
      } catch (error) {
        console.error('Error updating context:', error);
      }
    },
    async loadSessionHistory(session_id) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/chat/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId: session_id })
        });

        if (!response.ok) {
          console.warn('Failed to load session history:', response.status);
          return;
        }

        const data = await response.json();

        if (data.messages && data.messages.length > 0) {
          // Load previous messages into the chat
          // Remove first message if it exists
          if (data.messages.length > 0) {
            data.messages.shift();
          }
          this.messages = data.messages


          let paramCaseId = new URLSearchParams(window.location.search).get('caseId');
          if (paramCaseId && !this.messages.some(msg => msg.content.includes(paramCaseId))) {
            // Add case ID message if not already present
            this.messages.push({
              content: `Your HR request has been successfully submitted and is currently being processed. You can use the following Request ID: ${paramCaseId} to check the status of your submission. Please keep this reference number for future correspondence.`,
              role: 'assistant',
              timestamp: new Date()
            });
            this.messages.push({
              content: "Is there anything else I can help you with regarding your HR inquiry?",
              role: 'assistant',
              timestamp: new Date()
            });
            this.updateContext({
              content: `Your HR request has been successfully submitted and is currently being processed. You can use the following Request ID: ${paramCaseId} to check the status of your submission. Please keep this reference number for future correspondence.`,
              role: 'assistant',
              timestamp: new Date()
            }, this.sessionId, this.systemMessageFile);
            this.updateContext({
              content: "Is there anything else I can help you with regarding your HR inquiry?",
              role: 'assistant',
              timestamp: new Date()
            }, this.sessionId, this.systemMessageFile);
          }

          // Scroll to bottom after loading history
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      } catch (error) {
        console.error('Error loading session history:', error);
      }
    },
    formatMessageContent(content) {
    if(!content)
      return '';

      // First, escape HTML to prevent XSS, but preserve newlines
      let escapedContent = content
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

      // Convert \n to HTML line breaks
      let formattedContent = escapedContent.replace(/\\n|\n/g, '<br>');

      // Handle markdown-style formatting
      // Bold text: **text** or __text__
      formattedContent = formattedContent.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      formattedContent = formattedContent.replace(/__(.*?)__/g, '<strong>$1</strong>');
      
      // Italic text: *text* or _text_ (but not if already part of bold)
      formattedContent = formattedContent.replace(/(?<!\*)\*([^*]+?)\*(?!\*)/g, '<em>$1</em>');
      formattedContent = formattedContent.replace(/(?<!_)_([^_]+?)_(?!_)/g, '<em>$1</em>');

      // Code blocks: `code`
      formattedContent = formattedContent.replace(/`([^`]+?)`/g, '<code>$1</code>');

      // Regular expression to detect URLs, excluding trailing punctuation
      const urlRegex = /(https?:\/\/[^\s]+?)(?=[,;:!)>\]"'\s]|$)/g;

      // Document file extensions
      const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'zip', 'rar'];

      // Replace URLs with clickable links or attachment components
      return formattedContent.replace(urlRegex, (url) => {
        // Remove trailing dots from URL (keep first dot for extensions)
        const cleanUrl = url.replace(/\.+$/, '');

        // Check if URL ends with a document extension
        const urlLower = cleanUrl.toLowerCase();
        const isDocument = documentExtensions.some(ext => urlLower.endsWith(`.${ext}`));

        if (isDocument) {
          // Extract filename from URL
          const filename = cleanUrl.split('/').pop() || 'Document';
          const extension = filename.split('.').pop()?.toUpperCase() || 'FILE';

          return `<div class="attachment-container">
            <div class="attachment-icon">📎</div>
            <div class="attachment-info">
              <div class="attachment-name">${filename}</div>
              <div class="attachment-type">${extension} Document</div>
            </div>
            <a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" class="attachment-download">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
              </svg>
            </a>
          </div>`;
        } else {
          // Regular link
          // Check if URL contains /cases/new and add session_id parameter
          if (cleanUrl.includes('/cases/new')) {
            const url = new URL(cleanUrl);
            url.searchParams.set('session_id', this.sessionId);
            const modifiedUrl = url.toString();
            return `<div class="attachment-container">
            <div class="attachment-icon">⚖️</div>
            <div class="attachment-info">
                <div class="attachment-name">Submit HR Request Now</div>
            </div>
            <a href="${modifiedUrl}" rel="noopener noreferrer" class="attachment-download">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                </svg>
            </a>
          </div>`;
            // return dom.outerHTML;
          } else {
            return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" class="message-link">${cleanUrl}</a>`;
          }
          // return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" class="message-link">${cleanUrl}</a>`;
        }
      });
    },
    sendSuggestion(suggestion) {
      this.question = suggestion;
      this.sendQuestion();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = this.$refs.chatMessages;
          if (el) {
            // Primary method - set scrollTop
            el.scrollTop = el.scrollHeight;

            // Secondary method - scroll last message into view
            const lastMessage = el.lastElementChild;
            if (lastMessage) {
              lastMessage.scrollIntoView({
                behavior: 'auto', // Use auto instead of smooth for immediate effect
                block: 'end',
                inline: 'nearest'
              });
            }

            // Tertiary method - force scroll after delay
            setTimeout(() => {
              el.scrollTop = el.scrollHeight;
              // Call force method for really stubborn cases
              this.forceScrollToBottom();
            }, 50);
          }
        }, 50);
      });
    },
    forceScrollToBottom() {
      // More aggressive scrolling method for stubborn cases
      const el = this.$refs.chatMessages;
      if (!el) return;

      // Try multiple approaches
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      // Method 1: Direct scrollTop
      el.scrollTop = scrollHeight - clientHeight;

      // Method 2: scrollIntoView on last message
      const messages = el.querySelectorAll('.message');
      if (messages.length > 0) {
        const lastMessage = messages[messages.length - 1];
        lastMessage.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });
      }

      // Method 3: Fallback after delay
      setTimeout(() => {
        el.scrollTop = el.scrollHeight;
      }, 100);
    },
    generateSessionId(type) {
      return 'sess_' + type + '_' + Math.random().toString(36).substr(2, 9);
    },
    async startChat() {
      try {
        let sessionParamId = new URLSearchParams(window.location.search).get('sessionId');
        if (sessionParamId) {
          this.sessionId = sessionParamId;
          await this.loadSessionHistory(sessionParamId);
        } else {
          this.sessionId = this.generateSessionId('ct');
          this.mainSessionId = this.sessionId; // Mark as main session when creating new
          this.answer = '';
          this.error = '';
          this.messages = [];
          this.expandedMessages.clear(); // Clear expanded messages
          this.isManuallyExpanded = false; // Reset manual expansion
          // Add session ID to URL parameters
          const url = new URL(window.location);
          url.searchParams.set('sessionId', this.sessionId);
          window.history.replaceState({}, '', url);
        }
        
        // Initialize WebSocket session
        await this.initializeWebSocketSession();
      } catch (error) {
        console.error('Error starting chat:', error);
        this.error = 'Failed to start chat session. Please refresh the page and try again.';
      }
    },
    async sendQuestion() {
      try {
        await this._sendQuestionInternal();
      } catch (e) {
        // Final catch for any unhandled errors
        if (e.name === 'AbortError' || e.message?.includes('aborted')) {
          // This is expected when user cancels - do nothing
        } else {
          console.error('Unexpected error in sendQuestion:', e);
        }
      }
    },
    
    // WebSocket Chat API Methods
    async initializeWebSocketSession() {
      try {
        
        // Call the /chat/v3/start endpoint to initialize the session
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/chat/v3/start`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: this.sessionId,
            systemMessageFile: this.systemMessageFile,
            userID: this.userID
          })
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Session initialization failed:', response.status, errorText);
          throw new Error(`Failed to initialize session: ${response.status} - ${errorText}`);
        }

        const data = await response.json();

        // Verify session was created properly
        if (!data.sessionId || data.sessionId !== this.sessionId) {
          throw new Error('Session ID mismatch in initialization response');
        }

        // Add a small delay to ensure server-side session is fully ready
        await new Promise(resolve => setTimeout(resolve, 100));

        // Connect to WebSocket
        await this.connectWebSocket();
      } catch (error) {
        console.error('Error initializing WebSocket session:', error);
        this.error = `Failed to initialize chat session: ${error.message}. Please try again.`;
      }
    },

    async connectWebSocket() {
      return new Promise((resolve, reject) => {
        try {
          // Close existing connection if any
          this.closeWebSocketConnection();

          // Verify we have a valid session ID
          if (!this.sessionId) {
            reject(new Error('No session ID available for WebSocket connection'));
            return;
          }

          // Determine WebSocket URL based on environment
          const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3001';
          const wsUrl = baseUrl.replace(/^http/, 'ws') + `/chat-stream?sessionId=${this.sessionId}`;
          
          this.websocket = new WebSocket(wsUrl);

          this.websocket.onopen = () => {
            this.reconnectAttempts = 0;
            this.error = ''; // Clear connection errors
            this.startHeartbeat();
            this.$forceUpdate(); // Force UI update for connection status
            resolve();
          };

          this.websocket.onmessage = (event) => {
            this.handleWebSocketMessage(event);
          };

          this.websocket.onclose = (event) => {
            this.stopHeartbeat();
            this.$forceUpdate(); // Force UI update for connection status
            
            // Handle specific error codes
            if (event.code === 1008) {
              // Invalid session ID - need to reinitialize
              this.error = 'Session expired. Reinitializing...';
              setTimeout(() => {
                this.initializeWebSocketSession();
              }, 1000);
            } else if (event.code !== 1000 && this.sessionId && this.reconnectAttempts < this.maxReconnectAttempts) {
              // Other non-clean closes - attempt reconnection
              this.attemptReconnection();
            } else if (event.code !== 1000) {
              this.error = 'Connection lost. Please refresh the page to continue chatting.';
            }
          };

          this.websocket.onerror = (error) => {
            console.error('WebSocket error:', error);
            this.error = 'Connection error. Please check your internet connection.';
            this.$forceUpdate(); // Force UI update for connection status
            reject(error);
          };

          // Timeout for connection
          setTimeout(() => {
            if (this.websocket && this.websocket.readyState !== WebSocket.OPEN) {
              this.websocket.close();
              reject(new Error('WebSocket connection timeout'));
            }
          }, 10000);

        } catch (error) {
          console.error('Error creating WebSocket connection:', error);
          reject(error);
        }
      });
    },

    handleWebSocketMessage(event) {
      try {
        const message = JSON.parse(event.data);

        switch (message.type) {
          case 'connected':
            this.error = ''; // Clear any connection errors
            break;

          case 'text_delta':
            this.handleTextDelta(message);
            break;

          case 'text_done':
            this.handleTextDone(message);
            break;

          case 'response_done':
            this.handleResponseDone(message);
            break;

          case 'error':
            console.error('WebSocket error message:', message.error);
            this.error = message.error;
            this.loading = false;
            
            // Add error message to chat
            this.messages.push({
              role: 'assistant',
              content: `I apologize, but I encountered an error: ${message.error}. Please try sending your message again.`,
              timestamp: new Date()
            });
            
            this.$nextTick(() => {
              this.scrollToBottom();
            });
            break;

          case 'pong':
            // Heartbeat response received - connection is alive
            break;

          default:
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
        console.error('Raw message data:', event.data);
        
        // Don't show error to user for malformed messages unless it's critical
        if (this.loading) {
          this.loading = false;
          this.messages.push({
            role: 'assistant',
            content: 'I encountered an issue processing the response. Please try your question again.',
            timestamp: new Date()
          });
          
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      }
    },

    handleTextDelta(message) {
      
      // Handle streaming text deltas
      if (!this.loading) {
        // Start of a new response - reset answer accumulator
        this.loading = true;
        this.answer = '';
        this.error = ''; // Clear any errors
        
        // Add a new streaming message
        this.messages.push({
          role: 'assistant',
          content: '',
          streaming: true,
          timestamp: new Date()
        });
      }
      
      // Accumulate the delta text
      if (message.delta) {
        this.answer += message.delta;
        
        // Update the last message (which should be our streaming message)
        const lastMessage = this.messages[this.messages.length - 1];
        if (lastMessage && lastMessage.role === 'assistant' && lastMessage.streaming) {
          lastMessage.content = this.answer;
          
          // Force reactivity update
          this.$forceUpdate();
          
          // Auto-scroll during streaming with throttling
          this.throttledScroll();
        } else {
          console.error('Last message is not a streaming assistant message:', lastMessage);
        }
      }
    },

    // Throttled scroll function to prevent excessive scrolling during rapid updates
    throttledScroll: (() => {
      let scrollTimeout = null;
      return function() {
        if (scrollTimeout) return;
        
        scrollTimeout = setTimeout(() => {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
          scrollTimeout = null;
        }, 50); // Throttle to 20fps max
      };
    })(),

    handleTextDone(message) {
      
      // Handle complete text response
      this.loading = false;
      
      if (message.text) {
        // Find the streaming message and finalize it
        const lastMessage = this.messages[this.messages.length - 1];
        
        if (lastMessage && lastMessage.role === 'assistant' && lastMessage.streaming) {
          lastMessage.content = message.text;
          lastMessage.streaming = false;
        } else {
          // Fallback: add new message if streaming message not found
          this.messages.push({ 
            role: 'assistant', 
            content: message.text,
            streaming: false,
            timestamp: new Date()
          });
        }
        
        // Update the answer for any other components that might use it
        this.answer = message.text;
        
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
      
    },

    handleResponseDone(message) {
      // Final response completion
      this.loading = false;
      console.log('Response fully completed:', message?.response?.output[0]?.content);
    },

    closeWebSocketConnection() {
      if (this.websocket) {
        try {
          this.websocket.close(1000, 'Client disconnecting');
        } catch (error) {
          console.warn('Error closing WebSocket:', error);
        }
        this.websocket = null;
      }
      this.stopHeartbeat();
    },

    attemptReconnection() {
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        this.error = 'Connection lost. Please refresh the page to continue.';
        return;
      }

      this.reconnectAttempts++;
      
      setTimeout(() => {
        this.connectWebSocket().catch(error => {
          console.error('Reconnection failed:', error);
        });
      }, 2000 * this.reconnectAttempts); // Exponential backoff
    },

    startHeartbeat() {
      // Send ping every 30 seconds to keep connection alive
      this.heartbeatInterval = setInterval(() => {
        if (this.websocket && this.websocket?.readyState === WebSocket.OPEN) {
          this.websocket.send(JSON.stringify({ type: 'ping' }));
        }
      }, 30000);
    },

    stopHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },

    async _sendQuestionInternal() {
      if (!this.sessionId || !this.question.trim()) {
        this.error = 'No active session. Please start a chat.';
        return;
      }
      
      // Prevent multiple simultaneous requests
      if (this.loading) {
        return;
      }

      // Check WebSocket connection
      if (!this.websocket || this.websocket?.readyState !== WebSocket.OPEN) {
        console.log('WebSocket not connected, attempting to reconnect...');
        try {
          await this.connectWebSocket();
        } catch (error) {
          console.error('Failed to reconnect WebSocket:', error);
          this.error = 'Connection lost. Please refresh the page.';
          return;
        }
      }
      
      const userMsg = this.question;
      this.messages.push({ role: 'user', content: userMsg, timestamp: new Date() });
      this.question = ''; // Clear textbox immediately
      this.resetTextareaHeight(); // Reset textarea height

      // Immediate scroll for user message
      this.$nextTick(() => {
        this.scrollToBottom();
      });

      // Reset all response state - this is crucial!
      this.loading = false; // Will be set to true in handleTextDelta
      this.answer = '';
      this.error = '';
      
      try {
        // Send message via WebSocket
        const message = {
          type: 'message',
          content: userMsg
        };
        
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
          this.websocket.send(JSON.stringify(message));
        } else {
          throw new Error('WebSocket not available');
        }
        
      } catch (error) {
        console.error('Error sending WebSocket message:', error);
        this.error = 'Failed to send message. Please try again.';
        this.loading = false;
        
        // Add error message to chat
        this.messages.push({ 
          role: 'assistant', 
          content: 'I apologize, but I encountered an error while processing your message. Please try again.' ,
          timestamp: new Date()
        });
        
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    handleButtonClick() {
      try {
        if (this.loading) {
          this.stopRequest();
        } else {
          this.sendQuestion();
        }
      } catch (error) {
        if (error.name === 'AbortError' || error.message?.includes('aborted')) {
          // Expected abort error - no action needed
          console.log('Button click abort error handled');
        } else {
          console.error('Button click error:', error);
        }
      }
    },
    stopRequest() {
      if (this.loading) {
        this.loading = false;
        
        // For WebSocket, we can't easily stop a streaming response
        // but we can close and reconnect if needed
        
        // Add a message indicating the request was stopped
        if (this.messages.length > 0) {
          const lastMessage = this.messages[this.messages.length - 1];
          if (lastMessage.role === 'assistant' && lastMessage.streaming) {
            lastMessage.content += '\n\n[Response interrupted by user]';
            lastMessage.streaming = false;
          }
        }
        
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    async endChat(type) {
      // Clear URL parameters
      // Remove only the sessionId from the URL parameters
      const url = new URL(window.location);
      url.searchParams.delete('sessionId');
      window.history.replaceState({}, document.title, url.pathname + url.search);
      if (!this.sessionId) return;
      
      // Close WebSocket connection
      this.closeWebSocketConnection();
      
      this.loading = true;
      this.error = '';
      try {
        const res = await fetch(`${process.env.VUE_APP_API_BASE_URL}/chat/v3/end`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId: this.sessionId })
        });
        const data = await res.json();
        if (res.ok) {
          // this.sessionId = null;
          this.answer = '';
          this.question = '';
          this.systemMessageFile = 'HRMS';
          this.messages = [];
          this.expandedMessages.clear(); // Clear expanded messages
          this.isManuallyExpanded = false; // Reset manual expansion
          this.currentModule = null; // Reset current module
          this.startChat(); // Restart chat session
          if(type === 'button') {
            this.showFeedbackModal();
          }
        } else {
          this.error = data.error || 'Error ending chat';
        }
      } catch (e) {
        this.error = 'Network error';
      }
      this.loading = false;
    },
    onButtonTouchStart() {
      // Ensure touch events work properly on mobile devices
      // This helps with iOS Safari touch event handling
    },
    addEmoji(event) {
      this.question += event.detail.unicode;
      this.showEmojiPicker = false;
    },
    async startVoiceSession() {
      // Get a session token for OpenAI Realtime API
      const tokenResponse = await fetch(`${process.env.VUE_APP_API_BASE_URL}/token`, {
        method: 'POST',
        body: JSON.stringify({ systemMessageFile: this.systemMessageFile, userID: this.userID }),
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await tokenResponse.json();
      const EPHEMERAL_KEY = data.client_secret.value;
      this.systemURL = data.systemURL ? data.systemURL : "";
      this.systemAuthConfig = data.systemAuthConfig ? data.systemAuthConfig : null;
      this.toolsArray = data.toolsArray ? data.toolsArray : [];
      // Create a peer connection
      this.peerConnection = new RTCPeerConnection();

      // Set up to play remote audio from the model
      this.audioElement = this.$refs.audioElement;
      this.audioElement.autoplay = true;
      this.peerConnection.ontrack = (e) => (this.audioElement.srcObject = e.streams[0]);

      // Add local audio track for microphone input in the browser
      const ms = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.peerConnection.addTrack(ms.getTracks()[0]);

      // Set up data channel for sending and receiving events
      this.dataChannel = this.peerConnection.createDataChannel('oai-events');

      // Start the session using the Session Description Protocol (SDP)
      const offer = await this.peerConnection.createOffer();
      await this.peerConnection.setLocalDescription(offer);

      // Compose instructions (hardcoded for now)
      const instructions = `You are a sales agent for Dynamic Freelancer...`; // (use your full instructions here)
      function base64EncodeUnicode(str) {
        return btoa(unescape(encodeURIComponent(str)));
      }
      const originalSdp = offer.sdp;
      const modifiedSdp = originalSdp + `\r\na=system_message:${base64EncodeUnicode(instructions)}\r\n`;
      this.sessionId = this.generateSessionId('vc');
      this.voiceSessions[this.sessionId] = []; // Initialize voice session for this sessionId
      const sdpResponse = await fetch(`${process.env.VUE_APP_API_BASE_URL}/voice`, {
        method: "POST",
        body: JSON.stringify({
          modifiedSdp: modifiedSdp,
          sessionId: this.sessionId,
          EPHEMERAL_KEY: EPHEMERAL_KEY,
          systemMessageFile: this.systemMessageFile || undefined,
        }),
        headers: { 'Content-Type': 'application/json' }
      });

      const answer = {
        type: "answer",
        sdp: await sdpResponse.text(),
      };
      await this.peerConnection.setRemoteDescription(answer);


      // Listen for data channel events
      this.dataChannel.addEventListener("message", (e) => {
        const event = JSON.parse(e.data);
        if (event.type === 'conversation.item.input_audio_transcription.completed') {
          this.voiceSessions[this.sessionId].push({
            role: 'user',
            content: event.transcript
          });

          this.createLogWithSession(
            {
              role: 'user', content: event.transcript, timestamp: new Date(), usage: {
                promptTokens: 0,
                completionTokens: 0,
                totalTokens: 0
              }
            },
            this.sessionId,
            this.systemMessageFile || 'HRMS',
            this.voiceSessions[this.sessionId],
            this.userID || 'unknown_user',
            'voice'
          );
        }
        if (event.type === 'response.audio_transcript.done') {
          this.voiceSessions[this.sessionId].push({
            role: 'assistant',
            content: event.transcript
          });
          this.createLogWithSession(
            {
              role: 'assistant', content: event.transcript, timestamp: new Date(), usage: {
                promptTokens: 0,
                completionTokens: 0,
                totalTokens: 0
              }
            },
            this.sessionId,
            this.systemMessageFile || 'HRMS',
            this.voiceSessions[this.sessionId],
            this.userID || 'unknown_user',
            'voice'
          );
        }
        if (event.type === `response.function_call_arguments.done`) {
          this.callAPIArguments(
            event,
            this.systemURL,
            this.systemAuthConfig,
            event.arguments,
            event.name,
            this.toolsArray
          )
        }
        if (!event.timestamp) {
          event.timestamp = new Date().toLocaleTimeString();
        }
        if (event.type.startsWith('input_audio_buffer')) {
          if (this.pulseInterval) clearInterval(this.pulseInterval);
          this.pulseDuration = '2s'; // Reset pulse duration for new audio input
          this.pulseLoading = true; // Start pulse animation
        }
        else if (event.type == 'output_audio_buffer.stopped') {
          if (this.pulseInterval) clearInterval(this.pulseInterval);
          this.pulseDuration = '2s'; // Reset pulse duration for new audio input
          this.pulseLoading = true; // Start pulse animation
        }
        else if (event.type.startsWith('response')) {
          // Change pulse duration every 500ms for a more dynamic effect
          if (this.pulseInterval) clearInterval(this.pulseInterval);
          this.pulseInterval = setInterval(() => {
            let randomDuration = Math.random() * (0.6 - 0.4) + 0.4; // Random duration between 0.4s and 0.6s
            this.pulseDuration = `${randomDuration.toFixed(2)}s`;
          }, 300);
          this.pulseLoading = true; // Start pulse animation
        }
      });

      this.dataChannel.addEventListener("open", () => {
        this.isSessionActive = true;
        this.events = [];
        this.sendTextMessage(`Hi`, 'user');
        // this.$nextTick(() => {
        //   this.audioElement = this.$refs.audioElement;
        //   if (this.audioElement) {
        //     this.audioElement.autoplay = true;
        //     this.peerConnection.ontrack = (e) => {
        //       if (this.audioElement) {
        //         this.audioElement.srcObject = e.streams[0];
        //         this.audioElement.play().catch(console.warn);
        //       }
        //     };
        //   }
        // });
      });
    },
    stopVoiceSession() {
      if (this.dataChannel) {
        this.dataChannel.close();
      }
      if (this.peerConnection) {
        this.peerConnection.getSenders().forEach((sender) => {
          if (sender.track) sender.track.stop();
        });
        this.peerConnection.close();
      }
      this.isSessionActive = false;
      this.dataChannel = null;
      this.peerConnection = null;
    },
    closeVoiceSession() {
      this.createLogSummery(this.sessionId);
      this.voiceSessions = {}; // Clear voice sessions
      this.sessionId = null; // Reset session ID
      this.loading = false;
      this.sessionId = null;
      this.pulseLoading = false;

      // Clear pulse interval
      if (this.pulseInterval) clearInterval(this.pulseInterval);
      this.pulseInterval = null;

      // Clean up events and messages
      this.events = [];
      this.messages = [];
      this.expandedMessages.clear(); // Clear expanded messages
      this.isManuallyExpanded = false; // Reset manual expansion
      this.question = '';
      this.answer = '';
      this.error = '';

      // Clean up audio element
      if (this.audioElement) {
        this.audioElement.srcObject = null;
        this.audioElement.pause();
        this.audioElement.currentTime = 0;
      }

      // Clean up peer connection and data channel
      if (this.dataChannel) {
        this.dataChannel.close();
        this.dataChannel = null;
      }
      if (this.peerConnection) {
        this.peerConnection.getSenders().forEach(sender => {
          if (sender.track) sender.track.stop();
        });
        this.peerConnection.close();
        this.peerConnection = null;
      }

      this.isSessionActive = false;
      this.showVoiceSession = false;
      this.showFeedbackModal();
      this.startChat(); // Restart chat session
    },
    sendClientEvent(message) {
      if (this.dataChannel) {
        const timestamp = new Date().toLocaleTimeString();
        message.event_id = message.event_id || crypto.randomUUID();
        this.dataChannel.send(JSON.stringify(message));
        if (!message.timestamp) {
          message.timestamp = timestamp;
        }
        this.events.unshift(message);
      }
    },
    sendTextMessage(message, role = 'user') {
      const event = {
        type: "conversation.item.create",
        item: {
          type: "message",
          role: role,
          content: [
            {
              type: "input_text",
              text: message,
            },
          ],
        },
      };
      this.sendClientEvent(event);
      this.sendClientEvent({ type: "response.create" });
    },
    onTalkToAgent() {
      this.showVoiceSession = true;
      this.isSessionActive = false;
      this.startVoiceSession();
    },
    async createLogWithSession(message, sessionId, system, meta, user, type) {
      // This function should handle creating or updating logs with the provided parameters
      // Implement your logging logic here
      await fetch(`${process.env.VUE_APP_API_BASE_URL}/logs/createOrUpdateLogWithSession`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message,
          sessionId,
          system,
          meta,
          user,
          type,
          client: this.systemMessageFile || 'Undefined'
        })
      });
    },
    async createLogSummery(sessionId) {
      await fetch(`${process.env.VUE_APP_API_BASE_URL}/logs/summery`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId
        })
      });
    },
    async callAPIArguments(event, systemURL, systemAuthConfig, args, name, toolsArray) {
      try {
        let res = await fetch(`${process.env.VUE_APP_API_BASE_URL}/functions/executecallAPIArguments`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(
            {
              "url": systemURL,
              "authConfig": systemAuthConfig,
              "args": args,
              "toolName": name,
              "functionName": "callAPIArguments",
              "toolsArray": toolsArray
            }
          )
        })
        let response = await res.json();
        this.dataChannel.send(JSON.stringify(
          {
            type: "conversation.item.create",
            item:
            {
              type: "function_call_output",
              call_id: event.call_id,
              output: JSON.stringify(response)
            }
          }
        ));
        this.dataChannel.send(JSON.stringify({ type: 'response.create' }));
      }
      catch (error) {
        this.dataChannel.send(JSON.stringify(
          {
            type: "conversation.item.create",
            item:
            {
              type: "function_call_output",
              call_id: event.call_id,
              output: "Error calling function:" + error.message || "Unknown error"
            }
          }
        ));
        this.dataChannel.send(JSON.stringify({ type: 'response.create' }));
      }
    },

    getModuleIcon(module) {
      const moduleIcons = {
        'employee-list': 'mdi mdi-account-group',
        'add-employee': 'mdi mdi-account-plus',
        'view-payroll': 'mdi mdi-cash-multiple',
        'new-pay-item': 'mdi mdi-cash-plus',
        'view-process': 'mdi mdi-clipboard-list',
        'new-request': 'mdi mdi-clipboard-plus',
        'assets': 'mdi mdi-briefcase',
        'training-development': 'mdi mdi-school',
        'add-new-employee': 'mdi mdi-account-plus',
        'recruitment': 'mdi mdi-account-search',
        'requests': 'mdi mdi-clipboard-text'
      };
      return moduleIcons[module] || 'mdi mdi-help-circle';
    },

    getModuleName(module) {
      const moduleNames = {
        'employee-list': 'Employee List',
        'add-employee': 'Add Employee',
        'view-payroll': 'View Payroll',
        'new-pay-item': 'New Pay Item',
        'view-process': 'View Process',
        'new-request': 'New Request',
        'assets': 'Assets',
        'training-development': 'Training & Development',
        'add-new-employee': 'Add New Employee',
        'recruitment': 'Recruitment',
        'requests': 'Requests'
      };
      return moduleNames[module] || 'General HR';
    },

    getModuleSuggestions(module) {
      const moduleSuggestions = {
        'employee-list': [
          'Show me all employees with expired documents for the next 6 months',
          'Which employees have missing emergency contact details?',
          'List employees by location and department who are on probation',
          'Show me all employees with missing Work Schedules'
        ],
        'add-employee': [
          'List new joiners and their onboarding status',
          'How many requisitions are still open?',
          'Which candidates are in the final interview round?',
          'What information is required for new employees?'
        ],
        'view-payroll': [
          'What is the total payroll cost for August 2025?',
          'Get me the payslip for Arnold Raath',
          'List all approved recurring pay items still active',
          'Show me employees with salary changes in the last 3 months'
        ],
        'new-pay-item': [
          'List all pending pay item requests',
          'List all approved recurring pay items still active',
          'How do I set up salary components?',
          'What are the different pay item types?'
        ],
        'view-process': [
          'Show pending leave requests awaiting approval',
          'List employees who have not clocked in for 2 or more consecutive days',
          'Show me all pending reimbursement claims above 500 AED',
          'Generate a summary of letters requested but not yet signed'
        ],
        'requests': [
          'Show pending leave requests awaiting approval',
          'List all pending pay item requests',
          'Show me all pending reimbursement claims above 500 AED',
          'Generate a summary of letters requested but not yet signed'
        ],
        'assets': [
          'Show assigned laptops by department',
          'Which assets are due for return this month?',
          'List unassigned or lost assets in the past quarter',
          'How do I track asset locations?'
        ],
        'training-development': [
          'Which employees have overdue mandatory training?',
          'What was the participation rate for last month\'s sessions?',
          'List employees who completed more than 3 courses this year',
          'Which teams are lagging in skill development?'
        ],
        'add-new-employee': [
          'What information is required for new employees?',
          'Add New Employee'
        ],
        'recruitment': [
          'How many requisitions are still open?',
          'Which candidates are in the final interview round?',
          'List new joiners and their onboarding status',
          'How do I make a job offer?'
        ],
        'new-request': [
          'How many leave applications where made this year?',
          'Provide me the leave statement for Arnold Raath',
          'List all letters issued this month by type',
          'Who received salary certificates in the last 30 days?'
        ]
      };
      return moduleSuggestions[module] || [];
    },

    getConnectionStatusIcon() {
      if (!this.websocket) return 'mdi mdi-wifi-off';
      
      switch (this.websocket?.readyState) {
        case WebSocket.CONNECTING:
          return 'mdi mdi-loading mdi-spin';
        case WebSocket.OPEN:
          return 'mdi mdi-wifi';
        case WebSocket.CLOSING:
        case WebSocket.CLOSED:
          return 'mdi mdi-wifi-off';
        default:
          return 'mdi mdi-help-circle';
      }
    },

    getConnectionStatusText() {
      if (!this.websocket) return 'Disconnected';
      
      switch (this.websocket?.readyState) {
        case WebSocket.CONNECTING:
          return 'Connecting...';
        case WebSocket.OPEN:
          return 'Connected';
        case WebSocket.CLOSING:
          return 'Disconnecting...';
        case WebSocket.CLOSED:
          return 'Disconnected';
        default:
          return 'Unknown';
      }
    },

    canSendMessage() {
      if (this.loading) return true; // Allow stopping during loading
      
      // Check if we have a message to send
      if (!this.question.trim()) return false;
      
      // Check WebSocket connection
      if (!this.websocket || this.websocket?.readyState !== WebSocket.OPEN) return false;
      
      return true;
    },

    getSendButtonTooltip() {
      if (this.loading) return 'Stop current response';
      
      if (!this.question.trim()) return 'Type a message to send';
      
      if (!this.websocket || this.websocket?.readyState !== WebSocket.OPEN) {
        return 'Connection lost - unable to send message';
      }
      
      return 'Send message';
    },

    async manualReconnect() {
      try {
        // Clear any existing error state
        this.error = '';
        
        // Show connecting state
        this.$forceUpdate();
        
        // Reset reconnect attempts for manual reconnection
        this.reconnectAttempts = 0;
        
        // Attempt to reconnect
        await this.connectWebSocket();
        
        // Show success notification
        this.showNotification('Successfully reconnected to server', 'success');
        
      } catch (error) {
        console.error('Manual reconnection failed:', error);
        this.error = 'Failed to reconnect. Please try again or refresh the page.';
        this.showNotification('Reconnection failed. Please try again.', 'error');
      }
    },

    toggleFullScreen() {
      this.isManuallyExpanded = !this.isManuallyExpanded;
      
      // Force a re-render to update classes
      this.$nextTick(() => {
        this.$forceUpdate();
        
        // If expanding and there are messages, scroll to bottom
        if (this.isManuallyExpanded && this.messages.length > 0) {
          setTimeout(() => {
            this.scrollToBottom();
          }, 100);
        }
      });
    },

    // Session History Methods
    async loadSessionsList(append = false) {
      this.loadingHistory = true;
      
      // Store scroll position before loading if appending
      let scrollContainer, previousScrollTop;
      if (append) {
        scrollContainer = this.$refs.sessionListContainer;
        if (scrollContainer) {
          previousScrollTop = scrollContainer.scrollTop;
        }
      }
      
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/chat/sessions-history`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            system: "HRMS",
            userID: this.userID,
            page: this.currentPage,
            limit: this.sessionsPerPage
          })
        });

        if (!response.ok) {
          throw new Error('Failed to load session history');
        }

        const responseData = await response.json();
        
        // Map the API response to our session history format
        const newSessions = responseData.data.map(session => ({
          sessionId: session.sessionId,
          title: this.generateSessionTitle(session),
          createdAt: session.createdAt,
          preview: this.generateSessionPreview(session),
          messageCount: session.messageCount || 0,
          sessionStatus: session.sessionStatus,
          summery: session.summery
        }));
        
        // Either append to existing sessions or replace them
        if (append && this.currentPage > 1) {
          this.sessionHistory = [...this.sessionHistory, ...newSessions];
          
          // Restore scroll position after Vue updates the DOM
          this.$nextTick(() => {
            if (scrollContainer && previousScrollTop !== undefined) {
              scrollContainer.scrollTop = previousScrollTop;
            }
          });
        } else {
          this.sessionHistory = newSessions;
        }
        
        // Use pagination information from the response
        this.totalSessions = responseData.pagination.total || 0;
        
      } catch (error) {
        console.error('Error loading session history:', error);
        if (!append) {
          this.sessionHistory = [];
        }
      } finally {
        this.loadingHistory = false;
      }
    },

    generateSessionTitle(session) {
      // Use summary if available, otherwise generate title from metadata
      if (session.summery && session.summery.trim()) {
        return session.summery.substring(0, 50) + (session.summery.length > 50 ? '...' : '');
      }
      
      // Fallback to date-based title with status
      const date = new Date(session.createdAt);
      const timeStr = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      return `${session.system} Chat - ${timeStr}`;
    },

    generateSessionPreview(session) {
      // Use summary for preview if available
      if (session.summery && session.summery.trim()) {
        return session.summery.substring(0, 80) + (session.summery.length > 80 ? '...' : '');
      }
      
      // Generate preview from session metadata
      const statusText = session.sessionStatus === 'Resolved' ? 'Completed' : 'In Progress';
      const messageText = session.messageCount > 1 ? `${session.messageCount} messages` : '1 message';
      return `${statusText} • ${messageText}`;
    },

    formatSessionDate(dateString) {
      const date = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - date);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays === 1) {
        return 'Today';
      } else if (diffDays === 2) {
        return 'Yesterday';
      } else if (diffDays <= 7) {
        return `${diffDays - 1} days ago`;
      } else {
        return date.toLocaleDateString();
      }
    },

    formatDuration(seconds) {
      if (!seconds || seconds === 0) return '';
      
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    async saveCurrentSessionToHistory() {
      try {
        // Don't save the main session to history - it should stay as the current session
        if (this.sessionId === this.mainSessionId) {
          return;
        }

        // Don't save sessions with no messages - they shouldn't appear in history
        if (this.messages.length === 0) {
          return;
        }

        // Create a session object for the current session
        const currentSessionData = {
          sessionId: this.sessionId,
          title: this.generateCurrentSessionTitle(),
          createdAt: new Date().toISOString(),
          preview: this.generateCurrentSessionPreview(),
          messageCount: this.messages.length,
          sessionStatus: 'Active',
          summery: this.generateCurrentSessionSummary()
        };

        // Check if current session is already in the history
        const existingIndex = this.sessionHistory.findIndex(session => session.sessionId === this.sessionId);
        
        if (existingIndex !== -1) {
          // Update existing session
          this.sessionHistory[existingIndex] = currentSessionData;
        } else {
          // Add session to history (not at top, just in normal position)
          this.sessionHistory.unshift(currentSessionData);
        }
        
      } catch (error) {
        console.error('Error saving current session to history:', error);
      }
    },

    generateCurrentSessionTitle() {
      // Generate title from current messages
      if (this.messages.length > 0) {
        const firstUserMessage = this.messages.find(msg => msg.role === 'user');
        if (firstUserMessage && firstUserMessage.content) {
          return firstUserMessage.content.substring(0, 50) + (firstUserMessage.content.length > 50 ? '...' : '');
        }
      }
      
      // Fallback to time-based title
      const now = new Date();
      const timeStr = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      return `HRMS Chat - ${timeStr}`;
    },

    generateCurrentSessionPreview() {
      if (this.messages.length === 0) return 'No messages yet';
      
      const userMessages = this.messages.filter(msg => msg.role === 'user').length;
      const assistantMessages = this.messages.filter(msg => msg.role === 'assistant').length;
      
      return `${userMessages} questions • ${assistantMessages} responses`;
    },

    generateCurrentSessionSummary() {
      // Generate a brief summary from the first user message
      if (this.messages.length > 0) {
        const firstUserMessage = this.messages.find(msg => msg.role === 'user');
        if (firstUserMessage && firstUserMessage.content) {
          return firstUserMessage.content.substring(0, 100);
        }
      }
      return '';
    },

    async loadSession(sessionId) {
      if (sessionId === this.sessionId) return; // Already loaded
      if (this.sessionId && this.messages.length <= 1) {
        this.alreadyNewSession = this.sessionId;
      }
      
      this.loadingSession = true;
      
      try {
        // Only save to history if this is the main session and we're switching to a different one
        // Don't save when just browsing through history
        if (this.sessionId && this.messages.length > 0 && this.sessionId === this.mainSessionId) {
          await this.saveCurrentSessionToHistory();
        }

        // Close current WebSocket connection
        this.closeWebSocketConnection();

        // Clear current state without ending the session
        this.messages = [];
        this.expandedMessages.clear();
        this.isManuallyExpanded = false;
        this.question = '';
        this.answer = '';
        this.error = '';

        // Set the new session ID
        this.sessionId = sessionId;
        
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('sessionId', sessionId);
        window.history.replaceState({}, document.title, url.pathname + url.search);

        // Load session history
        await this.loadSessionHistory(sessionId);
        this.loadingSession = false;
        // Initialize WebSocket for the session
        await this.initializeWebSocketSession();

      } catch (error) {
        console.error('Error loading session:', error);
        this.error = 'Failed to load session. Please try again.';
      } finally {
        this.loadingSession = false;
      }
    },

    loadNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadSessionsList(true); // Append to existing sessions
      }
    },

    handleSessionScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      
      // Check if scrolled to bottom (with 20px threshold for better UX)
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        // Load more sessions if available and not already loading
        if (!this.loadingHistory && this.currentPage < this.totalPages) {
          this.loadNextPage();
        }
      }
    }
   
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.landing-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  position: relative;
  overflow-x: hidden;
  transition: all 0.3s ease;
  padding: 0px 20px;
}

.landing-container.expanded {
  background: #ffffff;
}

.landing-container.chat-active {
  padding: 0;
  background: #ffffff;
}

.landing-container.chat-active .top-right-icons {
  display: none;
}

/* Session History Sidebar */
.session-history-sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 20%;
  height: 100vh;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.session-history-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
}

.session-history-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

.session-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.new-chat-btn {
  background: #3b82f6;
  border: none;
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 6px;
  color: white;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.new-chat-btn:hover {
  background: #2563eb;
}

.new-chat-btn i {
  font-size: 14px;
}

.toggle-history-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  color: #6b7280;
  transition: all 0.2s ease;
}

.toggle-history-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

.session-history-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.session-list-container {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  padding-bottom: 0;
}

.loading-sessions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6b7280;
  gap: 12px;
}

.loading-sessions i {
  font-size: 24px;
  color: #3b82f6;
}

.loading-more-sessions {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  color: #6b7280;
  gap: 8px;
  font-size: 0.875rem;
}

.loading-more-sessions i {
  font-size: 16px;
  color: #3b82f6;
}

.loading-session-text {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-style: italic;
}

.loading-session-text i {
  color: #3b82f6;
  font-size: 16px;
}

.session-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.session-item {
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.session-item:hover {
  background: #f8fafc;
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.session-item.active {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border-color: #3b82f6;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.2);
}

.session-item.main-session {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  border-color: #10b981;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);
  position: relative;
}

.session-item.main-session::before {
  content: '📝';
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 12px;
  background: #10b981;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.session-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.session-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
  flex: 1;
  margin-right: 8px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
}

.main-session-label {
  color: #10b981;
  font-weight: 700;
  font-size: 0.75rem;
}

.session-status {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
}

.session-status.resolved {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.session-status.unresolved {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}

.session-status i {
  font-size: 12px;
}

.session-body {
  margin-bottom: 8px;
}

.session-date {
  font-size: 0.75rem;
  color: #6b7280;
  margin-bottom: 4px;
  font-weight: 500;
}

.session-preview {
  font-size: 0.75rem;
  color: #9ca3af;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
}

.session-id {
  font-size: 0.7rem;
  color: #9ca3af;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  margin-top: 4px;
  padding: 2px 6px;
  background: #f3f4f6;
  border-radius: 4px;
  display: inline-block;
}

.session-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.message-count,
.session-duration {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 8px;
}

.message-count i,
.session-duration i {
  font-size: 12px;
}

.show-history-btn {
  position: fixed;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0 8px 8px 0;
  padding: 12px 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 50;
  color: #6b7280;
}

.show-history-btn:hover {
  background: #f8fafc;
  border-color: #d1d5db;
  color: #374151;
}

/* Adjust main content when sidebar is visible */
.ai-content-wrapper.with-sidebar {
  margin-left: 20%;
  width: 80%;
}

.landing-container.chat-active .ai-content-wrapper.with-sidebar {
  padding: 0;
}

/* Top Right Icons */
.top-right-icons {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 12px;
  z-index: 10;
}

.icon-button {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.icon-button:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.icon-button i {
  font-size: 20px;
  color: #475569;
}

/* AI Content Wrapper */
.ai-content-wrapper {
  padding: 0px 20px;
  margin: 0 auto;
  transition: all 0.3s ease;
  min-height: inherit;
}

.ai-content-wrapper.chat-started {
  padding: 0;
}

.ai-content-wrapper.full-chat {
  padding: 0;
  height: 100vh;
  margin: 0;
  overflow: hidden;
}

/* Container Classes - Different containers with specific width constraints */

/* Base container for expanded content */
.expanded-content-container {
  margin: 0 auto;
  padding: 0 0px;
  width: 100%;
  box-sizing: border-box;
  padding-top: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* When manually expanded (full-chat mode) */
.ai-content-wrapper.full-chat .expanded-content-container {
  height: 100vh;
}

.ai-content-wrapper.full-chat .expanded-content-container .chat-container {
  flex: 1;
  height: 100%;
}

.ai-content-wrapper.full-chat .expanded-content-container .management-cards {
  display: none;
}

.ai-content-wrapper.full-chat .expanded-content-container .quick-actions-horizontal {
  display: none;
}

/* Normal (non-expanded) state height distribution */
.ai-content-wrapper:not(.full-chat) .expanded-content-container {
  height: 100vh; /* Set a specific height for the container */

}

.ai-content-wrapper:not(.full-chat) .management-cards {
  order: 1; /* Show first */
}

.ai-content-wrapper:not(.full-chat) .chat-container {
  order: 2; /* Show second */
}

.ai-content-wrapper:not(.full-chat) .quick-actions-horizontal {
  order: 3; /* Show last */
}

/* Chat header container - flexible width, no min-width to prevent overflow */
.chat-header-container {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

/* Chat messages container - constrained width when expanded */
.chat-messages-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;
}

/* Suggestions container - constrained width */
.suggestions-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;
}

/* Chat input container - flexible width, no min-width to prevent overflow */
.chat-input-container {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  position: relative;
}

/* Voice content container */
.voice-content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;
}

/* Apply min-width only to specific containers when expanded and screen is large enough */
@media (min-width: 1248px) {
  .landing-container.expanded .expanded-content-container,
  .landing-container.expanded .chat-messages-container,
  .landing-container.expanded .suggestions-container,
  .landing-container.expanded .voice-content-container {
    min-width: 1200px;
  }
  
  /* Keep header and input flexible to prevent overflow */
  .landing-container.expanded .chat-header-container,
  .landing-container.expanded .chat-input-container {
    max-width: 1200px;
    min-width: auto;
  }
}

/* Chat actions and title layout */
.chat-actions {
  flex-shrink: 0; /* Prevent the actions from shrinking */
}

.new-chat-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-title {
  flex: 1;
  min-width: 0; /* Allows the title to shrink if needed */
}

.chat-input-container {
  align-items: center;
  gap: 16px;
}

/* Responsive Design */
@media (max-width: 1248px) {
  .landing-container.expanded .expanded-content-container,
  .landing-container.expanded .chat-messages-container,
  .landing-container.expanded .suggestions-container,
  .landing-container.expanded .voice-content-container {
    min-width: auto;
    max-width: 100%;
    padding: 0 0px;
  }
  
  .chat-header-container,
  .chat-input-container {
    padding: 0 24px;
  }
}

@media (max-width: 768px) {
  .expanded-content-container,
  .chat-header-container,
  .chat-messages-container,
  .suggestions-container,
  .chat-input-container,
  .voice-content-container {
    max-width: 100%;
    padding: 0 0px;
  }
  
  .landing-container.expanded .expanded-content-container,
  .landing-container.expanded .chat-messages-container,
  .landing-container.expanded .suggestions-container,
  .landing-container.expanded .voice-content-container {
    min-width: auto;
  }
  
  .message-content {
    max-width: 85%;
  }
  
  .user-message .message-content {
    max-width: 90%;
  }
  
  .suggestion-chip {
    padding: 10px 14px;
    font-size: 0.8rem;
  }
  
  .message-input {
    font-size: 16px; /* Prevents zoom on iOS */
  }
  
  .chat-header-container,
  .chat-input-container {
    gap: 12px;
  }
  
  .attachment-btn,
  .send-button {
    width: 44px;
    height: 44px;
  }
  
  .message-input {
    height: 44px;
  }
}

/* Welcome Section */
.welcome-section {
  text-align: center;
  padding: 60px 20px 40px;
  margin-bottom: 40px;
}

.welcome-title h1 {
  font-size: 3rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
  line-height: 1.2;
}

.welcome-title p {
  font-size: 1.25rem;
  color: #64748b;
  margin-bottom: 8px;
}

.welcome-title .subtitle {
  font-size: 1rem;
  color: #94a3b8;
  font-weight: 500;
}

/* Management Cards */
.management-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: clamp(8px, 1.2vh, 15px); /* Responsive gap */
  margin-bottom: clamp(5px, 1vh, 10px); /* Responsive margin */
  flex: 0 0 17%; /* Take 19% of height when not expanded */
  overflow-y: auto;
}

.management-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: clamp(8px, 1.5vh, 15px); /* Smart responsive padding */
  border: 1px solid rgba(226, 232, 240, 0.8);
  transition: all 0.3s ease;
  height: 100%; /* Use full available height */
  display: flex;
  flex-direction: column;
}

.management-card:hover {
  border-color: rgba(37, 99, 235, 0.2);
}

.management-card h3 {
  font-size: clamp(0.995rem, 1.4vh, 1rem); /* Responsive font size */
  font-weight: 600;
  color: #1e293b;
  margin-bottom: clamp(6px, 1vh, 12px); /* Responsive margin */
  text-align: left;
}

.card-buttons {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(4px, 0.8vh, 8px); /* Responsive gap */
}

.card-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(6px, 1.5vh, 12px); /* Responsive gap */
  padding: clamp(6px, 1.2vh, 12px) clamp(8px, 1.5vh, 16px); /* Smart responsive padding */
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  color: inherit;
  min-height: clamp(32px, 4vh, 44px); /* Responsive min-height */
}

.card-button:hover {
  border-color: #2563eb;
  background: #f8fafc;
  transform: translateY(-1px);
}

.card-button i {
  font-size: clamp(14px, 1.8vh, 18px); /* Responsive icon size */
  color: #2563eb;
  flex-shrink: 0;
}

.card-button span {
  font-size: clamp(0.90rem, 1vh, 0.875rem); /* Responsive font size */
  font-weight: 500;
  color: #475569;
  text-align: left;
}

/* Chat Container */
.chat-container {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  min-width: 100%;
  flex-direction: column;
  margin: 0px;
  border: 1px solid rgba(226, 232, 240, 0.5);
  flex: 0 0 65%; /* Take 69% of height when not expanded */
}

.chat-container.full-height {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  margin: 0;
  border-radius: 0;
  z-index: 1000;
  flex: none; /* Override flex settings when in full height mode */
}

/* Chat Header */
.chat-header {
  padding: 8px 0;
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  backdrop-filter: blur(20px);
}

.chat-title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.service-icon {
  font-size: 28px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.service-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.service-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: -0.025em;
}

.session-id-display {
  font-size: 0.75rem;
  color: #9ca3af;
  font-weight: 400;
  margin-left: 8px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.chat-context {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #2563eb;
  font-size: 0.875rem;
  font-weight: 500;
}

.chat-context i {
  font-size: 14px;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.back-button:hover {
  background: linear-gradient(135deg, #1d4ed8, #1e40af);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.35);
}

.back-button:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.back-button:disabled:hover {
  background: #e5e7eb;
  transform: none;
  box-shadow: none;
}

.expand-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
  border: 2px solid rgba(37, 99, 235, 0.2);
  border-radius: 12px;
  cursor: pointer;
  font-size: 1.125rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-button:hover {
  background: rgba(37, 99, 235, 0.15);
  border-color: rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
}

.expand-button:active {
  transform: translateY(0);
}

.chat-title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.service-icon {
  font-size: 1.5rem;
}

.service-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.service-name {
  font-size: 1.125rem;
  font-weight: 600;
}

.chat-context {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.chat-context i {
  font-size: 14px;
  color: #2563eb;
}

.chat-context i.mdi-wifi {
  color: #10b981; /* Green for connected */
}

.chat-context i.mdi-wifi-off {
  color: #ef4444; /* Red for disconnected */
}

.chat-context i.mdi-loading {
  color: #f59e0b; /* Orange for connecting */
}

/* Chat Messages */
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  scroll-behavior: smooth;
}

.message {
  display: flex;
  gap: 12px;
  max-width: 100%;
  animation: fadeInUp 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 0 4px 0;
}

.message.user-message {
  align-self: flex-end;
  flex-direction: row-reverse;
  animation: slideInFromRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.message.assistant-message {
  animation: slideInFromLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.message-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.assistant-message .message-avatar {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
}

.user-message .message-avatar {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
}

.message-content {
  flex: 1;
  min-width: 0;
  max-width: 70%;
}

.user-message .message-content {
  max-width: 75%;
}

.message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  opacity: 0.8;
}

.message-sender {
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
}

.user-message .message-sender {
  color: #2563eb;
}

.assistant-message .message-sender {
  color: #2563eb;
}

.message-time {
  font-size: 0.75rem;
  color: #94a3b8;
}

.message-text {
  background: #ffffff;
  padding: 14px 18px;
  border-radius: 20px;
  color: #374151;
  line-height: 1.6;
  word-wrap: break-word;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  font-size: 0.95rem;
  position: relative;
  white-space: pre-wrap; /* Preserve whitespace and allow wrapping */
}

.message-text br {
  display: block;
  margin: 4px 0;
  content: "";
}

.assistant-message .message-text {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 20px 20px 20px 6px;
}

.user-message .message-text {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
  border: 1px solid rgba(37, 99, 235, 0.3);
  border-radius: 20px 20px 6px 20px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.message-text p {
  margin: 0 0 8px 0;
}

.message-text p:last-child {
  margin-bottom: 0;
}

.message-text strong {
  font-weight: 600;
}

.message-text em {
  font-style: italic;
  color: inherit;
}

.message-text code {
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.875em;
}

.user-message .message-text code {
  background: rgba(255, 255, 255, 0.2);
}

/* Show More/Less Button */
.message-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.expand-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(37, 99, 235, 0.1);
  border: 1px solid rgba(37, 99, 235, 0.2);
  border-radius: 50%;
  color: #2563eb;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.expand-btn:hover {
  background: rgba(37, 99, 235, 0.15);
  border-color: rgba(37, 99, 235, 0.4);
  transform: translateY(-1px);
}

.expand-btn i {
  font-size: 16px;
}

.show-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid rgba(37, 99, 235, 0.3);
  border-radius: 6px;
  color: #2563eb;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.show-more-btn:hover {
  background: rgba(37, 99, 235, 0.05);
  border-color: rgba(37, 99, 235, 0.5);
  transform: translateY(-1px);
}

.show-more-btn i {
  font-size: 14px;
}

.export-pdf-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2);
}

.export-pdf-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #b91c1c, #991b1b);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3);
}

.export-pdf-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1);
}

.export-pdf-btn i {
  font-size: 14px;
}

.export-pdf-btn.standalone-export {
  margin-top: 8px;
  background: linear-gradient(135deg, #059669, #047857);
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);
}

.export-pdf-btn.standalone-export:hover:not(:disabled) {
  background: linear-gradient(135deg, #047857, #065f46);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);
}

/* Excel Export Button Styles */
.export-excel-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #059669, #047857);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);
}

.export-excel-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #047857, #065f46);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);
}

.export-excel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.1);
}

.export-excel-btn i {
  font-size: 14px;
}

.export-excel-btn.standalone-export {
  margin-top: 8px;
  background: linear-gradient(135deg, #059669, #047857);
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);
}

.export-excel-btn.standalone-export:hover:not(:disabled) {
  background: linear-gradient(135deg, #047857, #065f46);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);
}

/* General Export Button Styles */
.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-message .expand-btn {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.9);
}

.user-message .expand-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
}

.user-message .show-more-btn {
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.3);
}

.user-message .show-more-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
}

.user-message .export-pdf-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.user-message .export-pdf-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.user-message .export-excel-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.user-message .export-excel-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

/* Notification Styles */
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  z-index: 9999;
  min-width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideInNotification 0.3s ease-out;
}

.notification.success {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.notification.error {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

@keyframes slideInNotification {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Truncated content styling */
.truncated-content {
  position: relative;
  transition: all 0.3s ease;
}

.truncated-content::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(transparent, currentColor);
  opacity: 0.1;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.user-message .truncated-content::after {
  background: linear-gradient(transparent, white);
  opacity: 0.2;
}

/* Message content animation */
.message-text > div {
  transition: all 0.3s ease;
}

/* Message Links */
.message-link {
  color: #2563eb;
  text-decoration: underline;
  transition: color 0.2s ease;
  word-break: break-all;
}

.message-link:hover {
  color: #1d4ed8;
}

.user-message .message-link {
  color: #93c5fd;
}

.user-message .message-link:hover {
  color: #bfdbfe;
}

/* Attachment Container */
.attachment-container {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(37, 99, 235, 0.05);
  border: 1px solid rgba(37, 99, 235, 0.2);
  border-radius: 8px;
  padding: 12px;
  margin: 8px 0;
  transition: all 0.2s ease;
}

.attachment-container:hover {
  background: rgba(37, 99, 235, 0.1);
  border-color: rgba(37, 99, 235, 0.3);
}

.attachment-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.attachment-info {
  flex: 1;
  min-width: 0;
}

.attachment-name {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 2px;
}

.attachment-type {
  font-size: 0.75rem;
  color: #6b7280;
}

.attachment-download {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #2563eb;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.attachment-download:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.user-message .attachment-container {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
}

.user-message .attachment-container:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.user-message .attachment-name {
  color: white;
}

.user-message .attachment-type {
  color: rgba(255, 255, 255, 0.7);
}

.user-message .attachment-download {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.user-message .attachment-download:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Welcome Context */
.welcome-context {
  margin-bottom: 16px;
}

.context-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(29, 78, 216, 0.1));
  color: #2563eb;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 600;
  border: 2px solid rgba(37, 99, 235, 0.2);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
  animation: fadeIn 0.6s ease-out;
}

.context-badge i {
  font-size: 16px;
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  gap: 4px;
  padding: 16px 20px;
  background: #f8fafc;
  border-radius: 20px 20px 20px 6px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2563eb;
  animation: typingPulse 1.4s ease-in-out infinite;
  opacity: 0.4;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

/* Streaming Indicator */
.streaming-indicator {
  display: inline-flex;
  gap: 2px;
  margin-left: 8px;
  align-items: center;
}

.streaming-indicator span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #2563eb;
  animation: streamingPulse 1.2s ease-in-out infinite;
  opacity: 0.6;
}

.streaming-indicator span:nth-child(2) {
  animation-delay: 0.15s;
}

.streaming-indicator span:nth-child(3) {
  animation-delay: 0.3s;
}

.user-message .streaming-indicator span {
  background: rgba(255, 255, 255, 0.8);
}

@keyframes typingPulse {
  0%, 60%, 100% {
    transform: scale(1);
    opacity: 0.4;
  }
  30% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes streamingPulse {
  0%, 60%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  30% {
    transform: scale(1.4);
    opacity: 1;
  }
}

/* Suggestions Bar */
.suggestions-bar {
  padding: 20px 0;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  animation: fadeInUp 0.6s ease-out;
}

.module-suggestions,
.general-suggestions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.suggestion-chip {
  padding: 5px 10px;
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 15px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.suggestion-chip:hover {
  background: #2563eb;
  border-color: #2563eb;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
}

.suggestion-chip:active {
  transform: translateY(-1px);
}

/* Chat Input */
.chat-input {
  display: flex;
  padding: 8px 0;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
  backdrop-filter: blur(20px);
}

.input-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attachment-btn {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  border: none;
  background: #f8fafc;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.attachment-btn:hover {
  background: #e5e7eb;
  color: #374151;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.message-input {
  flex: 1;
  padding: 14px 18px;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  font-size: 1rem;
  resize: none;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 120px;
  height: 48px;
  min-height: 48px;
  background: #ffffff;
  color: #374151;
  font-family: inherit;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  line-height: 1.4;
  overflow-y: auto;
}

.message-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.message-input::placeholder {
  color: #9ca3af;
}

.send-button {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  border: none;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.send-button:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  background: linear-gradient(135deg, #1d4ed8, #1e40af);
}

.send-button:active:not(:disabled) {
  transform: translateY(-1px) scale(1.02);
}

.send-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.send-button.stop-button {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.send-button.stop-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #b91c1c, #991b1b);
  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);
}

/* Connection Status Badge */
.connection-status-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 12px;
  font-size: 0.75rem;
  color: #ef4444;
  position: absolute;
  top: -30px;
  right: 0;
  white-space: nowrap;
  z-index: 10;
}

.connection-status-badge i {
  font-size: 12px;
}

.connection-status-badge i.mdi-loading {
  color: #f59e0b;
}

.connection-status-badge.connecting {
  background: rgba(245, 158, 11, 0.1);
  border-color: rgba(245, 158, 11, 0.2);
  color: #f59e0b;
}

/* Reconnect Button */
.reconnect-button {
  background: transparent;
  border: none;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
  color: inherit;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  min-height: 20px;
}

.reconnect-button:hover {
  background: rgba(0, 0, 0, 0.1);
  transform: rotate(180deg);
}

.reconnect-button.small {
  min-width: 16px;
  min-height: 16px;
  padding: 1px;
}

.reconnect-button i {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.reconnect-button.small i {
  font-size: 10px;
}

/* Chat context reconnect button */
.chat-context .reconnect-button {
  margin-left: 6px;
  color: #6b7280;
}

.chat-context .reconnect-button:hover {
  color: #374151;
  background: rgba(107, 114, 128, 0.1);
}

/* Quick Actions */
.quick-actions-horizontal {
  padding: clamp(3px, 0.6vh, 6px) 0px; /* Responsive padding */
  flex: 0 0 11%; /* Take 9% of height when not expanded */
  overflow-y: auto;
}

.quick-actions-horizontal h3 {
  text-align: left;
  font-size: clamp(0.875rem, 1.2vh, 1rem); /* Responsive font size */
  font-weight: 600;
  color: #1e293b;
  margin-bottom: clamp(4px, 0.8vh, 10px); /* Responsive margin */
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: clamp(4px, 0.8vh, 8px); /* Responsive gap */
  margin: 0 auto;
}

.quick-action-item {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 8px;
  padding: clamp(4px, 0.8vh, 8px) clamp(6px, 1vh, 12px); /* Smart responsive padding */
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(4px, 0.8vh, 8px); /* Responsive gap */
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-height: clamp(28px, 3vh, 36px); /* Responsive min-height */
}

.quick-action-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: rgba(37, 99, 235, 0.3);
}

.quick-action-item i {
  font-size: clamp(16px, 2vh, 20px); /* Responsive icon size */
  color: #2563eb;
  flex-shrink: 0;
}

.quick-action-item span {
  font-size: clamp(0.85rem, 1vh, 0.875rem); /* Responsive font size */
  font-weight: 500;
  color: #475569;
  text-align: left;
  flex: 1;
}

.ai-indicator {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-indicator i {
  font-size: 10px !important;
  color: white;
}

/* Voice Session */
.voice-session-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 600px;
  height: 70vh;
  max-height: 600px;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;
  padding: 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  z-index: 1000;
}

.voice-header {
  text-align: center;
  margin-bottom: 24px;
}

.voice-branding {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.voice-logo {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.logo-pulse {
  position: absolute;
  inset: -10px;
  border-radius: 50%;
  border: 2px solid rgba(37, 99, 235, 0.5);
  animation: pulse 2s infinite;
}

.voice-title h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 4px;
}

.voice-title p {
  font-size: 0.875rem;
  color: #94a3b8;
}

.voice-content {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  width: 100%;
}

.voice-connecting {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.connection-spinner {
  position: relative;
  width: 100px;
  height: 100px;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border: 3px solid transparent;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.spinner-ring:nth-child(2) {
  inset: 10px;
  animation-delay: -0.5s;
}

.spinner-ring:nth-child(3) {
  inset: 20px;
  animation-delay: -1s;
}

.voice-active {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.voice-visualizer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.visualizer-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.voice-waves {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 40px;
}

.wave {
  width: 4px;
  background: #2563eb;
  border-radius: 2px;
  height: 10px;
  transition: height 0.3s ease;
}

.wave.active {
  animation: wave 1s ease-in-out infinite;
}

.wave:nth-child(2) { animation-delay: 0.1s; }
.wave:nth-child(3) { animation-delay: 0.2s; }
.wave:nth-child(4) { animation-delay: 0.3s; }
.wave:nth-child(5) { animation-delay: 0.4s; }

.voice-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid rgba(37, 99, 235, 0.3);
}

.ai-avatar-gif {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pulse-animation {
  animation: avatarPulse 2s ease-in-out infinite;
}

.voice-status {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #2563eb;
}

.status-indicator.listening .status-dot {
  background: #f59e0b;
  animation: pulse 1s infinite;
}

.voice-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.control-hint {
  font-size: 0.875rem;
  color: #94a3b8;
}

.end-voice-btn {
  padding: 12px 24px;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.end-voice-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

.voice-footer {
  margin-top: 16px;
}

.tech-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 0.75rem;
  color: #94a3b8;
}

/* Voice Session Responsive */
@media (max-width: 768px) {
  .voice-session-container {
    width: 95%;
    height: 80vh;
    padding: 24px;
  }
  
  .voice-logo {
    width: 50px;
    height: 50px;
    font-size: 1.25rem;
  }
  
  .voice-title h3 {
    font-size: 1.125rem;
  }
  
  .voice-avatar {
    width: 60px;
    height: 60px;
  }
}

/* Feedback Modal */
.feedback-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.feedback-modal {
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.feedback-header {
  margin-bottom: 24px;
}

.feedback-icon {
  margin-bottom: 16px;
}

.feedback-logo {
  font-size: 2rem;
  margin-bottom: 16px;
}

.feedback-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.feedback-header p {
  color: #64748b;
}

.feedback-content {
  margin-bottom: 24px;
}

.rating-container {
  margin-bottom: 24px;
}

.rating-label {
  font-weight: 500;
  color: #475569;
  margin-bottom: 16px;
}

.rating-smileys {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.smiley-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.smiley-rating:hover,
.smiley-rating.active {
  background: #f1f5f9;
  transform: translateY(-2px);
}

.smiley {
  font-size: 2rem;
  filter: grayscale(1);
  transition: filter 0.2s ease;
}

.smiley-rating:hover .smiley,
.smiley-rating.active .smiley {
  filter: grayscale(0);
}

.rating-text {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
}

.feedback-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.feedback-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.feedback-btn.secondary {
  background: #f1f5f9;
  color: #64748b;
}

.feedback-btn.secondary:hover {
  background: #e2e8f0;
}

.feedback-btn.primary {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
}

.feedback-btn.primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(37, 99, 235, 0.3);
}

.feedback-btn.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.feedback-success {
  text-align: center;
}

.success-icon {
  font-size: 3rem;
  margin-bottom: 16px;
}

.feedback-success h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.feedback-success p {
  color: #64748b;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes wave {
  0%, 100% {
    height: 10px;
  }
  50% {
    height: 30px;
  }
}

@keyframes avatarPulse {
  0%, 100% {
    transform: scale(1);
    border-color: rgba(37, 99, 235, 0.3);
  }
  50% {
    transform: scale(1.05);
    border-color: rgba(37, 99, 235, 0.6);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .welcome-title h1 {
    font-size: 2rem;
  }
  
  .management-cards {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .card-buttons {
    grid-template-columns: 1fr;
  }
  
  .quick-actions-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .chat-container {
    margin: 10px;
    /* height: calc(100vh - 20px); */
  }
  
  .chat-container.full-height {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    height: 100vh;
    width: 100vw;
    border-radius: 0;
  }
  
  .message {
    max-width: 95%;
  }
  
  .rating-smileys {
    gap: 8px;
  }
  
  .smiley {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .top-right-icons {
    top: 16px;
    right: 16px;
    gap: 8px;
  }
  
  .icon-button {
    width: 36px;
    height: 36px;
  }
  
  .icon-button i {
    font-size: 16px;
  }
  
  .welcome-section {
    padding: 40px 16px 24px;
  }
  
  .welcome-title h1 {
    font-size: 1.75rem;
  }
  
  .management-cards {
    padding: 0 16px;
  }
  
  .quick-actions-horizontal {
    padding: 24px 16px;
  }
  
  .quick-actions-grid {
    grid-template-columns: 1fr;
  }
  
  .feedback-modal {
    padding: 24px;
    margin: 16px;
  }
}

/* Session History Responsive */
@media (max-width: 768px) {
  .session-history-sidebar {
    width: 30%;
  }
  
  .ai-content-wrapper.with-sidebar {
    margin-left: 30%;
    width: 70%;
  }
  
  .session-title {
    font-size: 0.8125rem;
  }
  
  .session-item {
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .session-history-sidebar {
    width: 100%;
    position: fixed;
    z-index: 1000;
  }
  
  .ai-content-wrapper.with-sidebar {
    margin-left: 0;
    width: 100%;
  }
  
  .show-history-btn {
    left: 4px;
    padding: 8px 4px;
  }
  
  /* Session history mobile optimizations */
  .session-item {
    padding: 12px;
    margin-bottom: 6px;
  }
  
  .session-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .session-title {
    font-size: 0.85rem;
    margin-right: 0;
  }
  
  .session-status {
    align-self: flex-end;
  }
  
  .session-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}

/* ============================================
   DARK MODE STYLES
   ============================================ */

/* Dark mode body and global overrides */
body.dark-mode {
  background: #0f172a;
  color: #e2e8f0;
}

/* Main container dark mode */
.landing-container.dark-mode {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
}

/* AI content wrapper dark mode */
.dark-mode .ai-content-wrapper {
  background: rgba(15, 23, 42, 0.95);
}

/* Chat container dark mode */
.dark-mode .chat-container {
  background: #1e293b;
  border-color: #334155;
}

/* Chat header dark mode */
.dark-mode .chat-header {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-bottom-color: #334155;
  color: #e2e8f0;
}

.dark-mode .header-title {
  color: #f1f5f9;
}

.dark-mode .header-subtitle {
  color: #94a3b8;
}

.dark-mode .connection-status {
  background: rgba(51, 65, 85, 0.6);
  color: #cbd5e1;
}

.dark-mode .connection-status.connected {
  background: rgba(16, 185, 129, 0.2);
  color: #6ee7b7;
}

.dark-mode .connection-status.disconnected {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
}

/* Chat messages area dark mode */
.dark-mode .chat-messages {
  background: #0f172a;
}

/* Message bubbles dark mode */
.dark-mode .message.user .message-bubble {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #ffffff;
  border-color: #2563eb;
}

.dark-mode .message.assistant .message-bubble {
  background: #1e293b;
  color: #e2e8f0;
  border-color: #334155;
}

.dark-mode .message-time {
  color: #64748b;
}

/* Welcome context dark mode */
.dark-mode .welcome-context {
  background: #1e293b;
  border-color: #334155;
}

.dark-mode .context-title {
  color: #f1f5f9;
}

.dark-mode .context-description {
  color: #94a3b8;
}

/* Module grid dark mode */
.dark-mode .module-card {
  background: #1e293b;
  border-color: #334155;
}

.dark-mode .module-card:hover {
  background: #334155;
  border-color: #475569;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.dark-mode .module-icon {
  color: #60a5fa;
}

.dark-mode .module-name {
  color: #f1f5f9;
}

/* Input area dark mode */
.dark-mode .chat-input-wrapper {
  background: #1e293b;
  border-top-color: #334155;
}

.dark-mode .message-input {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}

.dark-mode .message-input::placeholder {
  color: #64748b;
}

.dark-mode .message-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.dark-mode .send-button {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.dark-mode .send-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.dark-mode .send-button.stop-button {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

/* Suggestions dark mode */
.dark-mode .suggestions-container {
  background: rgba(30, 41, 59, 0.8);
  border-color: #334155;
}

.dark-mode .suggestion-chip {
  background: #334155;
  color: #e2e8f0;
  border-color: #475569;
}

.dark-mode .suggestion-chip:hover {
  background: #475569;
  border-color: #64748b;
}

/* Session history sidebar dark mode */
.dark-mode .session-history-sidebar {
  background: #1e293b;
  border-right-color: #334155;
}

.dark-mode .session-history-header {
  background: linear-gradient(to bottom, #1e293b, #334155);
  border-bottom-color: #334155;
}

.dark-mode .session-history-header h3 {
  color: #f1f5f9;
}

.dark-mode .session-item {
  background: #0f172a;
  border-color: #334155;
}

.dark-mode .session-item:hover {
  background: #334155;
  border-color: #475569;
}

.dark-mode .session-item.active {
  background: #334155;
  border-color: #3b82f6;
}

.dark-mode .session-title {
  color: #f1f5f9;
}

.dark-mode .session-preview {
  color: #94a3b8;
}

.dark-mode .session-date {
  color: #64748b;
}

.dark-mode .session-status {
  background: rgba(59, 130, 246, 0.2);
  color: #93c5fd;
}

/* Buttons dark mode */
.dark-mode .new-chat-btn,
.dark-mode .toggle-history-btn,
.dark-mode .show-history-btn {
  background: #334155;
  color: #e2e8f0;
}

.dark-mode .new-chat-btn:hover,
.dark-mode .toggle-history-btn:hover,
.dark-mode .show-history-btn:hover {
  background: #475569;
}

/* Loading and error states dark mode */
.dark-mode .loading-sessions {
  color: #94a3b8;
}

.dark-mode .error-container {
  background: rgba(239, 68, 68, 0.1);
  border-color: #dc2626;
  color: #fca5a5;
}

/* Attachment container dark mode */
.dark-mode .attachment-container {
  background: #334155;
  border-color: #475569;
}

.dark-mode .attachment-container:hover {
  background: #475569;
}

.dark-mode .attachment-name {
  color: #f1f5f9;
}

.dark-mode .attachment-type {
  color: #94a3b8;
}

.dark-mode .attachment-download {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}

.dark-mode .attachment-download:hover {
  background: rgba(59, 130, 246, 0.3);
}

/* Message link dark mode */
.dark-mode .message-link {
  color: #60a5fa;
}

.dark-mode .message-link:hover {
  color: #93c5fd;
}

/* Code blocks dark mode */
.dark-mode code {
  background: #0f172a;
  color: #e2e8f0;
  border: 1px solid #334155;
}

/* Scrollbar dark mode */
.dark-mode .chat-messages::-webkit-scrollbar-track {
  background: #0f172a;
}

.dark-mode .chat-messages::-webkit-scrollbar-thumb {
  background: #334155;
}

.dark-mode .chat-messages::-webkit-scrollbar-thumb:hover {
  background: #475569;
}

/* Export buttons dark mode */
.dark-mode .export-options {
  background: rgba(30, 41, 59, 0.95);
  border-color: #334155;
}

.dark-mode .export-btn {
  background: #334155;
  color: #e2e8f0;
  border-color: #475569;
}

.dark-mode .export-btn:hover {
  background: #475569;
}

/* Expand/collapse button dark mode */
.dark-mode .expand-message-btn {
  color: #60a5fa;
}

.dark-mode .expand-message-btn:hover {
  color: #93c5fd;
}

/* Voice session dark mode */
.dark-mode .voice-session-container {
  background: #1e293b;
  border-color: #334155;
}

.dark-mode .voice-header {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: #f1f5f9;
}

/* Feedback modal dark mode */
.dark-mode .feedback-overlay {
  background: rgba(0, 0, 0, 0.8);
}

.dark-mode .feedback-modal {
  background: #1e293b;
  border-color: #334155;
}

.dark-mode .feedback-modal h2 {
  color: #f1f5f9;
}

.dark-mode .feedback-modal p {
  color: #94a3b8;
}

/* Reconnect button dark mode */
.dark-mode .reconnect-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.dark-mode .reconnect-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

/* Full screen toggle dark mode */
.dark-mode .fullscreen-toggle {
  background: rgba(51, 65, 85, 0.8);
  color: #e2e8f0;
}

.dark-mode .fullscreen-toggle:hover {
  background: rgba(71, 85, 105, 0.9);
}

/* Welcome section dark mode */
.dark-mode .welcome-section {
  background: transparent;
}

.dark-mode .welcome-title h1 {
  color: #f1f5f9;
}

.dark-mode .welcome-title p {
  color: #94a3b8;
}

.dark-mode .welcome-title .subtitle {
  color: #64748b;
}

/* Management cards dark mode */
.dark-mode .management-card {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
}

.dark-mode .management-card:hover {
  background: rgba(51, 65, 85, 0.9);
  border-color: #3b82f6;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.2);
}

.dark-mode .management-card h3 {
  color: #f1f5f9;
}

.dark-mode .card-button {
  background: #0f172a;
  border-color: #334155;
}

.dark-mode .card-button:hover {
  background: #1e293b;
  border-color: #3b82f6;
}

.dark-mode .card-button i {
  color: #60a5fa;
}

.dark-mode .card-button span {
  color: #e2e8f0;
}

/* Session status badges dark mode */
.dark-mode .session-status.resolved {
  background: rgba(16, 185, 129, 0.2);
  color: #6ee7b7;
  border-color: rgba(16, 185, 129, 0.3);
}

.dark-mode .session-status.unresolved {
  background: rgba(251, 191, 36, 0.2);
  color: #fcd34d;
  border-color: rgba(251, 191, 36, 0.3);
}

/* Session metadata dark mode */
.dark-mode .session-id {
  background: #0f172a;
  color: #94a3b8;
  border: 1px solid #334155;
}

.dark-mode .message-count,
.dark-mode .session-duration {
  background: #0f172a;
  color: #94a3b8;
  border: 1px solid #334155;
}

/* Top right icon buttons dark mode */
.dark-mode .icon-button {
  background: rgba(30, 41, 59, 0.9);
  border: 1px solid #334155;
}

.dark-mode .icon-button:hover {
  background: rgba(51, 65, 85, 0.95);
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
}

.dark-mode .icon-button i {
  color: #e2e8f0;
}

/* Show history button dark mode */
.dark-mode .show-history-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark-mode .show-history-btn:hover {
  background: #334155;
  border-color: #475569;
  color: #e2e8f0;
}

/* Expanded content container dark mode */
.dark-mode .expanded-content-container {
  background: transparent;
}

/* Voice content dark mode */
.dark-mode .voice-content-container {
  background: #1e293b;
}

.dark-mode .voice-pulse {
  background: rgba(59, 130, 246, 0.3);
}

/* Loading spinner dark mode */
.dark-mode .loading-spinner {
  color: #60a5fa;
}

/* Error message dark mode */
.dark-mode .error-message {
  background: rgba(239, 68, 68, 0.1);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

/* Pagination dark mode */
.dark-mode .pagination-controls {
  background: #1e293b;
  border-top-color: #334155;
}

.dark-mode .pagination-btn {
  background: #334155;
  color: #e2e8f0;
  border-color: #475569;
}

.dark-mode .pagination-btn:hover:not(:disabled) {
  background: #475569;
  border-color: #64748b;
}

.dark-mode .pagination-btn:disabled {
  background: #1e293b;
  color: #64748b;
  border-color: #334155;
}

.dark-mode .page-info {
  color: #94a3b8;
}

/* Empty state dark mode */
.dark-mode .empty-sessions {
  color: #64748b;
}

/* Tooltip dark mode */
.dark-mode [title]:hover::after {
  background: #1e293b;
  color: #e2e8f0;
  border: 1px solid #334155;
}

/* New chat section dark mode */
.dark-mode .new-chat-section {
  background: transparent;
}

.dark-mode .chat-title {
  color: #f1f5f9;
}

/* Service name dark mode */
.dark-mode .service-name {
  color: #f1f5f9;
}

.dark-mode .session-id-display {
  color: #64748b;
}

/* Message text dark mode */
.dark-mode .message-text {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-mode .assistant-message .message-text {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.dark-mode .user-message .message-text {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #ffffff;
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.dark-mode .message-text strong {
  color: inherit;
}

.dark-mode .message-text em {
  color: inherit;
}

/* Chat input dark mode */
.dark-mode .chat-input {
  background: #1e293b;
  border-top-color: #334155;
}

.dark-mode .chat-input-container {
  background: transparent;
}

.dark-mode .attachment-btn {
  background: #334155;
  color: #94a3b8;
}

.dark-mode .attachment-btn:hover {
  background: #475569;
  color: #e2e8f0;
}

/* Quick action items dark mode */
.dark-mode .quick-action-item {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
  backdrop-filter: blur(10px);
}

.dark-mode .quick-action-item:hover {
  background: rgba(51, 65, 85, 0.95);
  border-color: #3b82f6;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.2);
}

.dark-mode .quick-action-item i {
  color: #60a5fa;
}

.dark-mode .quick-action-item span {
  color: #e2e8f0;
}

.dark-mode .ai-indicator {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

/* Chat context dark mode */
.dark-mode .chat-context {
  color: #60a5fa;
}

/* Back button dark mode */
.dark-mode .back-button {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.dark-mode .back-button:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.dark-mode .back-button:disabled {
  background: #334155;
  color: #64748b;
}

/* Input actions dark mode */
.dark-mode .input-actions {
  background: transparent;
}

/* End of dark mode styles */
</style>
  